export const riders = {
	D038: (
		<>
			<h2>Kód pojistného krytí: D038</h2>
			<p>
				POPIS: Připojištění denních dávek za dobu nezbytného léčení úrazu dítěte
				poskytuje účinnou pojistnou ochranu, která je určena na krytí drobných i
				větších úrazů dítěte, zejména hlavy, krku, hrudníku, břicha, horních a
				dolních končetin, ale i dalších částí těla.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz dítěte vyjmenovaný v příloze pojistných podmínek,
				který je léčen pod dohledem lékaře a jehož nezbytné léčení trvalo déle
				než 7 po sobě následujících dní.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka (denní odškodné) za každý den
				nezbytného léčení (maximálně však po dobu stanovenou pro jednotlivé
				úrazy v příloze pojistných podmínek). Pokud si nezbytné léčení úrazu do
				24 hodin od okamžiku úrazu vyžádá pobyt v nemocnici delší než 24 hodin,
				zvyšuje se po dobu hospitalizace denní dávka na dvoj-násobek.
			</p>
		</>
	),
	D053: (
		<>
			<h2>D053 - Připojištění smrti nebo diagnózy závažného onemocnění</h2>
		</>
	),
	D118: (
		<>
			<h2>Kód pojistného krytí: D118</h2>
			<p>
				POPIS: Připojištění trvalých následků úrazu dítěte s progresivním
				plněním poskytuje účinnou pojistnou ochranu, která zaručuje finanční
				odškodnění v případě trvalého poškození po úrazu dítěte. Každý potřebuje
				mít pojištěny malé i velké úrazy, protože každý je denně vystaven mnoha
				rizikům. Od toho je zde právě připojištění trvalých následků s
				progresivním plněním až 400 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající trvalé následky uvedené v
				pojistných podmínkách, pokud jsou trvalé následky příslušným lékařem
				diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) vynásobené tzv. koeficientem progrese v závislosti na rozsahu
				trvalých následků.
			</p>
		</>
	),
	DBA5: "-",
	DBC5: (
		<>
			<h2>
				DBC5 - Pripoistenie denných dávok za dobu nevyhnutného liečenia úrazu
				dieťaťa
			</h2>
		</>
	),
	DBC6: "-",
	DWR0: (
		<>
			<h2>DWR0 - Samostatnosť</h2>
		</>
	),
	DWR3: (
		<>
			<h2>DWR3 - Samostatnosť</h2>
		</>
	),
	DWRP: "-",
	DWRS: "-",
	E140: (
		<>
			<h2>E140 - Indiánské léto</h2>
		</>
	),
	E150: (
		<>
			<h2>E150 - Životní pojištění Investor Plus</h2>
		</>
	),
	E1R0: (
		<>
			<h2>E1R0 - Zmiešané životné poistenie</h2>
		</>
	),
	E1R3: (
		<>
			<h2>E1R3 - Zmiešané životné poistenie</h2>
		</>
	),
	E1RP: "-",
	E1RS: "-",
	E1S0: (
		<>
			<h2>E1S0 - Zmiešané životné poistenie</h2>
		</>
	),
	E1S3: (
		<>
			<h2>E1S3 - Zmiešané životné poistenie</h2>
		</>
	),
	E1SP: "-",
	E1SS: "-",
	EXR0: (
		<>
			<h2>EXR0 - Variant</h2>
		</>
	),
	EXR3: (
		<>
			<h2>EXR3 - Variant</h2>
		</>
	),
	EXRP: "-",
	EXRS: "-",
	EXS0: (
		<>
			<h2>EXS0 - Variant</h2>
		</>
	),
	EXS3: (
		<>
			<h2>EXS3 - Variant</h2>
		</>
	),
	EXSP: "-",
	EXSS: "-",
	F018: (
		<>
			<h2>Kód pojistného krytí: F018</h2>
			<p>
				Název připojištění: Připojištění úrazu a trvalých následků úrazu dítěte
			</p>
			<p>
				Popis připojištění: Připojištění úrazu a trvalých následků úrazu dítěte
				poskytuje finanční pomoc v případě trvalého poškození po úrazu dítěte.
				Každý z nás je denně vystaven mnoha rizikům, a proto potřebujeme mít
				pojištěny malé i velké úrazy. Od toho je zde právě připojištění úrazů a
				jejich trvalých následků s pojistným plněním od 1 % pojistné částky.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<ol type="a">
					<li>Úraz uvedený v příloze pojistných podmínek;</li>
					<li>
						trvalé následky úrazu uvedené v příloze pojistných podmínek nastalé
						do 3 let od data úrazu;
					</li>
					<li>
						hospitalizace v důsledku úrazu (musí trvat minimálně 8 po sobě
						následujících dní).
					</li>
				</ol>
			</p>
		</>
	),
	F030: (
		<>
			<h2>Kód pojistného krytí: F030</h2>
			<p>Název připojištění: Připojištění pro případ úrazu</p>
			<p>
				Popis připojištění: Připojištění pro případ úrazu poskytuje účinnou
				ochranu určenou ke krytí drobných i větších úrazů a v těchto případech
				zaručující jednoduchou a rychlou pomoc.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz pojištěného uvedený v příloze pojistných
				podmínek.
			</p>
		</>
	),
	F101: (
		<>
			<h2>Kód pojistného krytí: F101</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici následkem úrazu
				poskytuje pojistnou ochranu pro případ hospitalizace následkem úrazu.
				Díky těmto finančním prostředkům si můžete zajistit nadstandardní
				nemocniční péči, sjednat pomoc v domácnosti v době své nepřítomnosti
				nebo pomoci své rodině s cestovními náklady při návštěvách v nemocnici.
				Pro toto připojištění platí pojistné podmínky produktu CHU1.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace v důsledku úrazu (musí trvat minimálně
				24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	F118: (
		<>
			<h2>Kód pojistného krytí: F118</h2>
			<p>
				Název připojištění: Připojištění trvalých následků úrazu dítěte s
				progresivním plněním
			</p>
			<p>
				Popis připojištění: Připojištění trvalých následků úrazu dítěte s
				progresivním plněním poskytuje účinnou ochranu zaručující finanční
				odškodnění v případě trvalého poškození po úrazu dítěte. Každý z nás je
				denně vystaven mnoha rizikům, a proto potřebujeme mít pojištěny malé i
				velké úrazy. Právě od toho je zde připojištění trvalých následků s
				progresivním plněním až 400 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající do 3 let od svého vzniku trvalé
				následky uvedené v příloze pojistných podmínek.
			</p>
		</>
	),
	FAR1: (
		<>
			<h2>FAR1 - Poistná suma na úraz</h2>
		</>
	),
	FBR1: (
		<>
			<h2>FBR1 - Životné poistenie Komplet</h2>
		</>
	),
	FDR3: (
		<>
			<h2>FDR3 - Pripoistenie poúrazovej hospitalizácie</h2>
		</>
	),
	FHR1: (
		<>
			<h2>FHR1 - Denné odškodné v prípade poúrazovej hospitalizácie</h2>
		</>
	),
	FLR4: (
		<>
			<h2>FLR4 - Životné poistenie Komplet</h2>
		</>
	),
	FLRP: "-",
	FY1C: (
		<>
			<h2>FY1C - Pojištění pro případ smrti</h2>
		</>
	),
	G001: (
		<>
			<h2>G001 - Připojištění pro případ smrti</h2>
		</>
	),
	G002: (
		<>
			<h2>G002 - Připojištění pro případ smrti úrazem</h2>
		</>
	),
	G003: (
		<>
			<h2>G003 - Připojištění pro případ smrti úrazem</h2>
		</>
	),
	G004: (
		<>
			<h2>G004 - Připojištění trvalých následků úrazu</h2>
		</>
	),
	G005: (
		<>
			<h2>G005 - Připojištění trvalých následků úrazu</h2>
		</>
	),
	G006: (
		<>
			<h2>G006 - Zproštění od placení pojistného</h2>
		</>
	),
	G012: (
		<>
			<h2>G012 - Připojištění pro případ smrti následkem úrazu</h2>
		</>
	),
	G013: (
		<>
			<h2>G013 - Připojištění pro případ smrti následkem úrazu</h2>
		</>
	),
	G014: (
		<>
			<h2>
				G014 - Připojištění pro případ smrti následkem úrazu a trvalých následků
				úrazu
			</h2>
		</>
	),
	G015: (
		<>
			<h2>
				G015 - Připojištění pro případ smrti následkem úrazu a trvalých následků
				úrazu
			</h2>
		</>
	),
	G110: (
		<>
			<h2>G110 - Kapitálové životní pojištění</h2>
		</>
	),
	G120: (
		<>
			<h2>G120 - Kapitálové životní pojištění</h2>
		</>
	),
	G220: (
		<>
			<h2>G220 - Kapitálově důchodové pojištění</h2>
		</>
	),
	GLR0: (
		<>
			<h2>GLR0 - Dožitie konca poistnej doby</h2>
		</>
	),
	GLRP: "-",
	GLS0: (
		<>
			<h2>GLS0 - Mimoriadne poistné</h2>
		</>
	),
	GTU4: (
		<>
			<h2>GTU4 - Finančné fondy životného poistenia s garantovanou výplatou</h2>
		</>
	),
	H100: (
		<>
			<h2>Kód pojistného krytí: H100</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici poskytuje
				pojistnou ochranu pro případ hospitalizace. Díky těmto finančním
				prostředkům si můžete zajistit nadstandardní nemocniční péči, sjednat
				pomoc v domácnosti v době své nepřítomnosti nebo pomoci své rodině s
				cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace (musí trvat: v případě úrazu minimálně 4
				kalendářní dny, při porodu 8 kalendářních dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka platná k datu hospitalizace za
				každý kalendářní den hospitalizace. Maximální délka výplaty denní dávky
				je 52 týdnů.
			</p>
		</>
	),
	CID1: (
		<>
			<h2>Kód pojistného krytí: CID1</h2>
			<p>
				POPIS: Připojištění pro případ invalidity poskytuje komplexní pojistnou
				ochranu a pojištěný se tak v případě uznání plné invalidity nemusí
				obávat o snížení svého životního standardu.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Uznání 3. stupně invalidity (dříve plná invalidita)
				pojišťovnou, jestliže z důvodu dlouhodobě nepříznivého zdravotního stavu
				došlo k poklesu schopnosti soustavné výdělečné činnosti nejméně o 70 % a
				pojištěný žádnou soustavnou výdělečnou činnost neprovozuje nebo pro
				zdravotní postižení je schopen soustavné výdělečné činnosti jen za zcela
				mimořádných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistná částka platná ke dni vzniku pojistné události.
				Vyplácí se ve 2 platbách, a to 30 % po uznání plné invalidity
				pojišťovnou, a 70 % pojistného plnění 12 měsíců po vzniku pojistné
				události prokáže-li pojištěný, že neschopnost vykonávat soustavnou
				výdělečnou činnost v požadovaném rozsahu dále trvá.
			</p>
		</>
	),
	CID2: (
		<>
			<h2>Kód pojistného krytí: CID2</h2>
			<p>
				POPIS: Připojištění pro případ invalidity poskytuje komplexní pojistnou
				ochranu a pojištěný se tak v případě uznání plné invalidity nemusí
				obávat o snížení svého životního standardu.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Uznání 3. stupně invalidity (dříve plná invalidita)
				pojišťovnou, jestliže z důvodu dlouhodobě nepříznivého zdravotního stavu
				došlo k poklesu schopnosti soustavné výdělečné činnosti nejméně o 70 % a
				pojištěný žádnou soustavnou výdělečnou činnost neprovozuje nebo pro
				zdravotní postižení je schopen soustavné výdělečné činnosti jen za zcela
				mimořádných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistná částka platná ke dni vzniku pojistné události.
				Vyplácí se ve 2 platbách, a to 30 % po uznání plné invalidity
				pojišťovnou, a 70 % pojistného plnění 12 měsíců po vzniku pojistné
				události, prokáže-li pojištěný, že neschopnost vykonávat soustavnou
				výdělečnou činnost v požadovaném rozsahu dále trvá.
			</p>
		</>
	),
	CID3: (
		<>
			<h2>Kód pojistného krytí: CID3</h2>
			<p>
				POPIS: Připojištění pro případ invalidního důchodu poskytuje komplexní
				pojistnou ochranu pro případ invalidity (1., 2. i 3. stupně) a pojištěný
				se tak v těchto případech nemusí se obávat o snížení svého životního
				standardu. Pojistné plnění z tohoto připojištění je jednorázovou formou.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 1., 2. nebo 3. stupeň invalidity. Pokles pracovní
				schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu musí být
				nejméně o 35 % (max. však o 49 %) u invalidity 1. stupně, nejméně o 50 %
				(max. však o 69 %) u invalidity 2. stupně anebo nejméně o 70 % u
				invalidity 3. stupně + příslušný stupeň invalidity musí být uznán v
				rámci posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 1. stupeň invalidity = 20 % sjednané pojistné částky 2.
				stupeň invalidity = 100 % sjednané pojistné částky 3. stupeň invalidity
				= 100 % sjednané pojistné částky Progrese ve výši 150 % = v případě 3.
				stupně invalidity a jedné z diagnóz – kvadruplegie nebo terminální
				onemocnění.
			</p>
		</>
	),
	CIR0: (
		<>
			<h2>CIR0 - Pripoistenie kritických chorôb</h2>
		</>
	),
	CIR1: (
		<>
			<h2>CIR1 - Pripoistenie kritických chorôb</h2>
		</>
	),
	CIR2: (
		<>
			<h2>CIR2 - Diagnostikovanie kritickej choroby</h2>
		</>
	),
	CIR3: (
		<>
			<h2>CIR3 - Pripoistenie kritických chorôb</h2>
		</>
	),
	CIR5: "-",
	CLC3: (
		<>
			<h2>Kód pojistného krytí: CLC3</h2>
			<p>Název připojištění: Připojištění pro případ nesoběstačnosti</p>
			<p>
				Popis připojištění: Připojištění pro případ nesoběstačnosti je unikátní
				připojištění, které zajišťuje finanční pomoc v případě, kdy pojištěný
				nemůže z důvodu úrazu či nemoci samostatně provádět činnosti, jako jsou
				příjem stravy, dodržování pitného režimu, mytí těla, koupání nebo
				sprchování, výkon fyziologické potřeby včetně hygieny, oblékání,
				svlékání, obouvání, zouvání, mobilita (změna polohy těla atd.) či pohyb
				jako takový.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Nesoběstačnost pojištěného v důsledku úrazu a/nebo
				nemoci, čímž se pojištěný stává neschopným k provádění činností
				vymezených v pojistných podmínkách.
			</p>
		</>
	),
	CLR4: (
		<>
			<h2>CLR4 - Komplet Junior</h2>
		</>
	),
	CLRP: "-",
	CNL1: (
		<>
			<h2>Kód pojistného krytí: CNL1</h2>
			<p>
				POPIS: Připojištění denních dávek za dobu nezbytného léčení úrazu
				poskytuje účinnou pojistnou ochranu, která je určena na krytí drobných i
				větších úrazů, zejména hlavy, krku, hrudníku, břicha, horních a dolních
				končetin, ale i dalších částí těla – celkem 418 diagnóz. Pokud si
				nezbytné léčení do 24 hodin od okamžiku úrazu vyžádá pobyt v
				hospitalizaci delší než 24 hodin, zvyšuje se po dobu hospitalizace
				pojistné plnění na dvojnásobek. Součástí je i tzv. bonus za bezeškodní
				průběh, kdy za každý rok (s výjimkou prvního), ve kterém nebyl vůči
				pojišťovně uplatňován nárok na pojistné plnění z tohoto připojištění,
				poskytne pojišťovna ve prospěch pojistné smlouvy bonus za bezeškodní
				průběh ve výši 10 % pojistného zaplaceného za toto připojištění v
				uplynulém roce.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Nezbytné léčení tělesného poškození způsobeného úrazem
				za předpokladu, že je vyjmenováno v příloze pojistných podmínek (vždy
				pod dohledem lékaře a trvající minimálně 8 po sobě následujících dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka za každý den nezbytného léčení.
				Pokud si nezbytné léčení do 24 hodin od okamžiku úrazu vyžádá pobyt v
				nemocnici delší než 24 hodin, zvyšuje se po dobu hospitalizace denní
				dávka na dvojnásobek.
			</p>
		</>
	),
	CNL2: (
		<>
			<h2>Kód pojistného krytí: CNL2</h2>
			<p>
				POPIS: Připojištění denních dávek za dobu nezbytného léčení úrazu dítěte
				poskytuje účinnou pojistnou ochranu, která je určena na krytí drobných i
				větších úrazů zejména hlavy, krku, hrudníku, břicha, horních a dolních
				končetin, ale i dalších částí těla – celkem 424 diagnóz úrazu s
				připodobňováním, není-li daný úraz vyjmenovaný. Součástí je i tzv. bonus
				za bezeškodní průběh, kdy za každý rok (s výjimkou prvního), ve kterém
				nebyl vůči pojišťovně uplatňován nárok na pojistné plnění z tohoto
				připojištění, poskytne pojišťovna ve prospěch pojistné smlouvy bonus za
				bezeškodní průběh ve výši 10 % pojistného zaplaceného za toto
				připojištění v uplynulém roce.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Nezbytné léčení tělesného poškození způsobeného úrazem
				za předpokladu, že je vyjmenováno v příloze pojistných podmínek nebo jej
				lze na základě posouzení lékaře pojišťovny k tam uvedenému tělesnému
				poškození připodobnit (vždy pod dohledem lékaře a trvající minimálně 8
				po sobě následujících dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka za každý den nezbytného léčení.
				Pokud si nezbytné léčení do 24 hodin od okamžiku úrazu vyžádá pobyt v
				nemocnici delší než 24 hodin, zvyšuje se po dobu hospitalizace denní
				dávka na 1,5násobek.
			</p>
		</>
	),
	COP1: (
		<>
			<h2>Kód pojistného krytí: COP1</h2>
			<p>
				POPIS: Připojištění pro případ zproštění od placení pojistného zajišťuje
				pojistníkovi především prostředky na platbu pojistného (za všechna
				pojištění/připojištění na pojistné smlouvě) v případě, že by byl uznán
				plně invalidním (dnes 3. stupeň invalidity). V takovém případě je
				pojistník zproštěn od povinnosti platit pojistné (pojistné za pojistníka
				hradí pojišťovna). Pojistné krytí přitom zůstává tak, jak je.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Uznání 3. stupně invalidity (dříve plná invalidita)
				pojišťovnou, jestliže z důvodu dlouhodobě nepříznivého zdravotního stavu
				došlo k poklesu schopnosti soustavné výdělečné činnosti nejméně o 66 % a
				pojištěný žádnou soustavnou výdělečnou činnost neprovozuje nebo pro
				zdravotní postižení je schopen soustavné výdělečné činnosti jen za zcela
				mimořádných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Zproštění pojistníka od povinnosti platit pojistné za
				hlavní krytí i veškerá připojištění sjednaná v pojistné smlouvě
				(pojistné za pojistníka hradí pojišťovna).
			</p>
		</>
	),
	COP2: (
		<>
			<h2>Kód pojistného krytí: COP2</h2>
			<p>
				POPIS: Připojištění pro případ zproštění od placení pojistného (s
				výplatou renty) zajišťuje pojistníkovi především prostředky na platbu
				pojistného (za všechna pojištění/připojištění na pojistné smlouvě) v
				případě, že by byl uznán invalidním 3. stupně. V takovém případě je
				pojistník zproštěn od povinnosti platit pojistné (pojistné za pojistníka
				hradí pojišťovna). Pojistné krytí přitom zůstává tak, jak je. Výplata
				renty (označuje se kódem CRI1) je volitelným doplňkem tohoto
				připojištění.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 3. stupeň invalidity. Pokles pracovní schopnosti z
				důvodu dlouhodobě nepříznivého zdravotního stavu musí být nejméně o 70 %
				+ 3. stupeň invalidity musí být uznán v rámci posudku příslušného orgánu
				sociální zprávy (ČSSZ).
			</p>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<p>
				a) zproštění pojistníka od povinnosti platit pojistné za hlavní krytí i
				veškerá připojištění sjednaná v pojistné smlouvě (pojistné za pojistníka
				hradí pojišťovna).
			</p>
			<p>
				b) a výplata pojistného plnění ve formě renty, pokud je k tomuto
				připojištění výslovně sjednána (vyplácí se po dobu trvání zproštění od
				placení v pravidelných měsíčních dávkách, jejichž výše je dohodnuta v
				pojistné smlouvě, a to podle volby při oznámení pojistné události).
			</p>
		</>
	),
	COP4: (
		<>
			<h2>COP4 - Připojištění pro případ zproštění od placení pojistného</h2>
		</>
	),
	CPN1: (
		<>
			<h2>Kód pojistného krytí: CPN1</h2>
			<p>
				POPIS: Připojištění pro případ pracovní neschopnosti poskytuje účinnou
				pojistnou ochranu v případě pracovní neschopnosti. Díky těmto finančním
				prostředkům si můžete zajistit nadstandardní nemocniční péči či sjednat
				pomoc v domácnosti. Součástí je i tzv. bonus za bezeškodní průběh, kdy
				za každý rok (s výjimkou prvního), ve kterém nebyl vůči pojišťovně
				uplatňován nárok na pojistné plnění z tohoto připojištění, poskytne
				pojišťovna ve prospěch pojistné smlouvy bonus za bezeškodní průběh ve
				výši 10 % pojistného zaplaceného za toto připojištění v uplynulém roce.
			</p>
			<p>POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost.</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka platná k datu pracovní
				neschopnosti za každý den od 29. dne pracovní neschopnosti. Maximální
				délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	CPN2: (
		<>
			<h2>Kód pojistného krytí: CPN2</h2>
			<p>
				POPIS: Připojištění pro případ pracovní neschopnosti zajišťuje finanční
				pomoc v případě, kdy pojištěný nemůže podle lékařského rozhodnutí žádným
				způsobem vykonávat a nevykonává své zaměstnání nebo svou samostatnou
				výdělečnou činnost. Součástí je i tzv. bonus za bezeškodní průběh, kdy
				za každý rok (s výjimkou prvního), ve kterém nebyl vůči pojišťovně
				uplatňován nárok na pojistné plnění z tohoto připojištění, poskytne
				pojišťovna ve prospěch pojistné smlouvy bonus za bezeškodní průběh ve
				výši 10 % pojistného zaplaceného za toto připojištění v uplynulém roce.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost pojištěného
				(podmínkou je trvání pracovní neschopnosti minimálně 29 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka od 29. dne lékařem přiznané
				pracovní neschopnosti (max. však ve výši odpovídající skutečné ztrátě na
				výdělku pojištěného; tento limit neplatí, pokud sjednaná denní dávka
				nepřesahuje maximální sjednanou denní dávku stanovenou pojišťovnou, u
				které se příjem pojištěného nezkoumá). Maximální délka denní dávky je 52
				týdnů .
			</p>
		</>
	),
	CPN3: (
		<>
			<h2>Kód pojistného krytí: CPN3</h2>
			<p>
				POPIS: Připojištění pro případ pracovní neschopnosti zajišťuje finanční
				pomoc v případě, kdy pojištěný nemůže podle lékařského rozhodnutí žádným
				způsobem vykonávat a nevykonává své zaměstnání nebo svou samostatnou
				výdělečnou činnost. Součástí je i tzv. bonus za bezeškodní průběh, kdy
				za každý rok (s výjimkou prvního), ve kterém nebyl vůči pojišťovně
				uplatňován nárok na pojistné plnění z tohoto připojištění, poskytne
				pojišťovna ve prospěch pojistné smlouvy bonus za bezeškodní průběh ve
				výši 10 % pojistného zaplaceného za toto připojištění v uplynulém roce.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost pojištěného
				(podmínkou je trvání pracovní neschopnosti minimálně 29 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka od 29. dne lékařem přiznané
				pracovní neschopnosti (max. však ve výši odpovídající skutečné ztrátě na
				výdělku pojištěného; tento limit neplatí, pokud sjednaná denní dávka
				nepřesahuje maximální sjednanou denní dávku stanovenou pojišťovnou, u
				které se příjem pojištěného nezkoumá). Maximální délka denní dávky je 52
				týdnů.
			</p>
		</>
	),
	CPU1: (
		<>
			<h2>Kód pojistného krytí: CPU1</h2>
			<p>
				POPIS: Připojištění denní dávky při pracovní neschopnosti následkem
				úrazu zajišťuje finanční pomoc v případě, kdy pojištěný nemůže z důvodu
				úrazu vykonávat své zaměstnání nebo svou samostatnou výdělečnou činnost.
				Součástí je i tzv. bonus za bezeškodní průběh, kdy za každý rok (s
				výjimkou prvního), ve kterém nebyl vůči pojišťovně uplatňován nárok na
				pojistné plnění z tohoto připojištění, poskytne pojišťovna ve prospěch
				pojistné smlouvy bonus za bezeškodní průběh ve výši 10 % pojistného
				zaplaceného za toto připojištění v uplynulém roce.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Pracovní neschopnost pojištěného v důsledku úrazu
				(podmínkou je trvání pracovní neschopnosti minimálně 15 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka od 1. dne pracovní neschopnosti
				(max. však ve výši odpovídající skutečné ztrátě na výdělku pojištěného;
				tento limit neplatí, pokud sjednaná denní dávka nepřesahuje maximální
				sjednanou denní dávku stanovenou pojišťovnou, u které se příjem
				pojištěného nezkoumá). Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	CPU3: (
		<>
			<h2>Kód pojistného krytí: CPU3</h2>
			<p>
				POPIS: Připojištění denní dávky při pracovní neschopnosti následkem
				úrazu zajišťuje finanční pomoc v případě, kdy pojištěný nemůže z důvodu
				úrazu podle lékařského rozhodnutí žádným způsobem vykonávat a nevykonává
				své zaměstnání nebo svou samostatnou výdělečnou činnost. Součástí je i
				tzv. bonus za bezeškodní průběh, kdy za každý rok (s výjimkou prvního),
				ve kterém nebyl vůči pojišťovně uplatňován nárok na pojistné plnění z
				tohoto připojištění, poskytne pojišťovna ve prospěch pojistné smlouvy
				bonus za bezeškodní průběh ve výši 10 % pojistného zaplaceného za toto
				připojištění v uplynulém roce.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost pojištěného v
				důsledku úrazu (podmínkou je trvání pracovní neschopnosti minimálně 29
				dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka od 1. dne lékařem přiznané
				pracovní neschopnosti (max. však ve výši odpovídající skutečné ztrátě na
				výdělku pojištěného; tento limit neplatí, pokud sjednaná denní dávka
				nepřesahuje maximální sjednanou denní dávku stanovenou pojišťovnou, u
				které se příjem pojištěného nezkoumá). Maximální délka výplaty denní
				dávky je 52 týdnů.
			</p>
		</>
	),
	CRDF: (
		<>
			<h2>Kód pojistného krytí: CRDF</h2>
			<p>
				Název připojištění: Zproštění od placení pojistného pro případ pracovní
				neschopnosti a pro případ ztráty zaměstnání
			</p>
			<p>
				Popis připojištění: Pojištění Zproštění od placení pojistného pro případ
				pracovní neschopnosti a pro případ ztráty zaměstnání zajistí prostředky
				na platbu pojistného (za všechna pojištění/připojištění na Vaší pojistné
				smlouvě u NN Životní pojišťovny) při pracovní neschopnosti nebo při
				ztrátě zaměstnání trvající nepřetržitě 60 kalendářních dní nebo více. V
				takovém případě jste zproštěn od povinnosti platit pojistné (pojistné za
				Vás hradí BNP Paribas Cardif Pojišťovna, a.s. ).
			</p>
			<p>
				POJISTNÁ UDÁLOST: Pracovní neschopnost nebo nezaměstnanost (v obou
				případech trvající nepřetržitě min. 60 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Výše plnění se rovná měsíčním předpisům pojistného za
				všechna pojištění/připojištění na Vaší pojistné smlouvě. Plnění vyplácí
				BNP Paribas Cardif Pojišťovna, a.s. přímo NN Životní pojišťovně (plnění
				je poskytováno od 61. dne). Plnění z jedné pojistné události může činit
				maximálně 12 po sobě jdoucích úhrad měsíčního předpisu pojistného (v
				maximální výši měsíčního předpisu pojistného 55 555 Kč).
			</p>
			<p>
				Připojištění CDRF se řídí pojistnými podmínkami společnosti
				<a href="http://www.bnpparibas.cz/ " target="_blank" rel="noreferrer">
					BNP Paribas Cardif pojišťovna, a.s.
				</a>
				, které jsou k dohledaní na jejich oficiálních stránkách.
			</p>
		</>
	),
	CRI1: (
		<>
			<h2>Kód pojistného krytí: CRI1</h2>
			<p>
				POPIS: Připojištění výplaty renty ke zproštění od placení pojistného je
				doplňkem k pojištění/připojištění zproštění od placení pojistného, ať
				již je zproštění od placení pojistného samostatným připojištěním nebo
				součástí hlavního krytí. Zajišťuje finanční pomoc pro případ invalidity
				3. stupně/plné invalidity a pojištěný se tak v těchto případech nemusí
				se obávat o snížení svého životního standardu.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Invalidita, tak jak je definována v pojistných
				podmínkách pro zproštění od placení pojistného, jehož je toto
				připojištění CRI1 doplňkem.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Výplata pojistného plnění ve formě pravidelné renty
				(vyplácí se po dobu trvání zproštění od placení v pravidelných měsíčních
				dávkách, jejichž výše je dohodnuta v pojistné smlouvě nebo v návrhu na
				změnu pojistné smlouvy, kterým je toto připojištění sjednáno k pojistné
				smlouvě, a to podle volby při oznámení pojistné události.
			</p>
		</>
	),
	CS21: (
		<>
			<h2>Kód pojistného krytí: CS21</h2>
			<p>
				POPIS: Hlavní krytí pro 2. pojištěného - Životní pojištění Rodina /
				Životní pojištění NN Smart / Životní pojištění ZFP Život+.
			</p>
		</>
	),
	CSO1: (
		<>
			<h2>Kód pojistného krytí: CSO1</h2>
			<p>
				POPIS: Připojištěním pro případ smrti se zvyšuje pojistné plnění pro
				případ smrti z jakékoliv příčiny (při pojistné události smrt se pak
				vyplácí pojistné plnění jak z hlavního krytí, tak i z tohoto
				připojištění).
			</p>
			<p>POJISTNÁ UDÁLOST: Smrt z jakékoliv příčiny.</p>
			<p>POJISTNÉ PLNĚNÍ: Pojistná částka platná k datu pojistné události.</p>
		</>
	),
	CSO2: "-",
	CSO3: (
		<>
			<h2>Kód pojistného krytí: CSO3</h2>
			<p>Název připojištění: Připojištění pro případ smrti</p>
			<p>
				Popis připojištění: Připojištěním pro případ smrti se zvyšuje pojistné
				plnění pro případ smrti z jakékoliv příčiny (při pojistné události smrt
				se pak vyplácí pojistné plnění jak z hlavního krytí, tak i z tohoto
				připojištění).
			</p>
			<p>POJISTNÁ UDÁLOST: Smrt z jakékoliv příčiny.</p>
		</>
	),
	CTN2: (
		<>
			<h2>Kód pojistného krytí: CTN2</h2>
			<p>
				POPIS: Připojištění pro případ trvalých následků úrazu dítěte s
				progresivním plněním poskytuje finanční pomoc v případě trvalého
				poškození po úrazu dítěte. Každý potřebuje mít pojištěny malé i velké
				úrazy, protože každý je denně vystaven mnoha rizikům. Od toho je zde
				právě připojištění trvalých následků s pojistným plněním od 1 % pojistné
				částky, neomezeným počtem diagnóz (400+) s progresivním plněním až 400
				%.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz dítěte zanechávající trvalé následky, pokud jsou
				trvalé následky příslušným lékařem diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) vynásobené tzv. koeficientem progrese v závislosti na rozsahu
				trvalých následků. V případě vyjmenovaných trvalých následků úrazu
				dítěte v obličeji, získává dítě automaticky navíc i tzv. dětské plnění
				trvalých následků úrazu v obličeji.
			</p>
		</>
	),
	CTN3: (
		<>
			<h2>Kód pojistného krytí: CTN3</h2>
			<p>
				Název připojištění: Připojištění pro případ trvalých následků úrazu nebo
				nemoci
			</p>
			<p>
				Popis připojištění: Připojištění pro případ trvalých následků úrazu nebo
				nemoci poskytuje ochranu pro případ vybraných trvalých následků úrazu
				nebo nemoci a v těchto případech zaručuje jednoduchou a rychlou pomoc.
				Každá diagnóza je ohodnocena pevnou částkou pojistného plnění.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz a/nebo nemoc zanechávající do 3 let od svého
				vzniku trvalé následky uvedené v příloze pojistných podmínek.
			</p>
		</>
	),
	CTU2: (
		<>
			<h2>Kód pojistného krytí: CTU2</h2>
			<p>
				Název připojištění: Připojištění pro případ trvalých následků úrazu
				dítěte s progresivním plněnímPopis připojištění: Připojištění trvalých
				následků úrazu dítěte s progresivním plněním poskytuje účinnou ochranu
				zaručující finanční odškodnění v případě trvalého poškození po úrazu
				dítěte. Každý z nás je denně vystaven mnoha rizikům, a proto potřebujeme
				mít pojištěny malé i velké úrazy. Právě od toho je zde připojištění
				trvalých následků s progresivním plněním až 400 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající do 3 let od svého vzniku trvalé
				následky uvedené v příloze pojistných podmínek.
			</p>
		</>
	),
	CTU4: (
		<>
			<h2>CTU4 - Mimoriadne poistné</h2>
		</>
	),
	CUD1: (
		<>
			<h2>Kód pojistného krytí: CUD1</h2>
			<p>
				POPIS: Připojištění pro případ plného invalidního důchodu následkem
				úrazu poskytuje účinnou pojistnou ochranu pro případ plné invalidity
				(dnes invalidita 3. stupně) způsobené úrazem a pojištěný se tak v těchto
				případech nemusí se obávat o snížení svého životního standardu.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Uznání 3. stupně invalidity (dříve plná invalidita)
				následkem úrazu pojišťovnou, jestliže z důvodu dlouhodobě nepříznivého
				zdravotního stavu došlo k poklesu schopnosti soustavné výdělečné
				činnosti nejméně o 66 % a pojištěný žádnou soustavnou výdělečnou činnost
				neprovozuje, nebo pro zdravotní postižení je schopen soustavné výdělečné
				činnosti jen za zcela mimořádných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve formě důchodu, který se vyplácí v
				pravidelných měsíčních dávkách ve výši 1/12 pojistné částky, platné ke
				dni pojistné události. Důchod bude vyplácen ode dne pojistné události,
				nejdříve však po uplynutí 6 měsíců od úrazu, v jehož důsledku pojistná
				událost nastala. V době výplaty důchodu pojišťovna k výročnímu dni
				počátku připojištění zvýší roční hodnotu důchodu o 5 % z pojistné částky
				platné ke dni pojistné události. Dnem konce připojištění končí výplata
				důchodu a připojištění zaniká.
			</p>
		</>
	),
	CUD2: (
		<>
			<h2>Kód pojistného krytí: CUD2</h2>
			<p>
				POPIS: Připojištění pro případ invalidního důchodu následkem úrazu s
				výplatou renty poskytuje pojistnou ochranu pro případ invalidity 3.
				stupně způsobené úrazem a pojištěný se tak v těchto případech nemusí se
				obávat o snížení svého životního standardu. Pojistné plnění z tohoto
				připojištění je formou měsíční výplaty. Součástí je i tzv. bonus za
				bezeškodní průběh, kdy za každý rok (s výjimkou prvního), ve kterém
				nebyl vůči pojišťovně uplatňován nárok na pojistné plnění z tohoto
				připojištění, poskytne pojišťovna ve prospěch pojistné smlouvy bonus za
				bezeškodní průběh ve výši 10 % pojistného zaplaceného za toto
				připojištění v uplynulém roce.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 3. stupeň invalidity následkem úrazu. Pokles pracovní
				schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu musí být
				nejméně o 70 % + 3. stupeň invalidity musí být uznán v rámci posudku
				příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve formě renty, která se vyplácí v
				pravidelných měsíčních dávkách ve výši 1/12 pojistné částky platné ke
				dni vzniku pojistné události. Po zahájení výplaty renty se vždy k
				výročnímu dni počátku připojištění roční hodnota renty navýší o 5 % (z
				pojistné částky platné ke dni vzniku pojistné události). Za určitých
				podmínek bude pojišťovna pokračovat s výplatou renty i po zániku tohoto
				připojištění až do dosažení věku 65 let pojištěného.
			</p>
		</>
	),
	CZR1: (
		<>
			<h2>Kód pojistného krytí: CZR1</h2>
			<p>
				POPIS: Připojištění pro případ rakoviny dospělých poskytuje účinnou
				pojistnou ochranu v případě, že Vás v průběhu života postihne toto
				závažné onemocnění.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Stanovení diagnózy rakoviny, terminální fáze rakoviny
				(s bonusem 50 % pojistné částky) a/nebo diagnózy tzv. rakoviny in situ.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši sjednané pojistné částky nebo
				její části, a to v závislosti na typu diagnózy (procentuální hodnota
				pojistného plnění ve vztahu ke sjednané pojistné částce je uvedena v
				příloze pojistných podmínek).
			</p>
		</>
	),
	CZV1: (
		<>
			<h2>Kód pojistného krytí: CZV1</h2>
			<p>
				POPIS: Připojištění pro případ závažných onemocnění dospělých zajišťuje
				finanční pomoc v případě, kdy pojištěného postihne některé z
				terminálních nebo závažných onemocnění (srdeční infarkt, mrtvice,
				rakovina, selhání ledvin, transplantace životně důležitých orgánů,
				náhrada srdeční chlopně, operace aorty, AIDS, HIV infekce, oslepnutí,
				ztráta sluchu, operace věnčitých tepen – bypass, onemocnění plic
				způsobující dechovou nedostatečnost, nitrolební nádory nezhoubného
				původu, roztroušená skleróza, encefalitida nebo žloutenka a mnoho
				dalších).
			</p>
			<p>
				POJISTNÁ UDÁLOST: Stanovení diagnózy závažného onemocnění anebo
				podstoupení některé z operací dle pojistných podmínek (s bonusem 50 %
				pojistné částky v případě terminální fáze rakoviny).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši sjednané pojistné částky nebo
				její části, a to v závislosti na typu závažného onemocnění (procentuální
				hodnota pojistného plnění ve vztahu ke sjednané pojistné částce je
				uvedena v příloze pojistných podmínek).
			</p>
		</>
	),
	CZV2: (
		<>
			<h2>Kód pojistného krytí: CZV2</h2>
			<p>
				POPIS: Připojištění pro případ závažných onemocnění dětí poskytuje
				pojistnou ochranu pro případ, že Vaše dítě postihne některé ze závažných
				onemocnění. Připojištění zahrnuje 55 nejčastějších diagnóz jako je
				rakovina, transplantace orgánů, cukrovka, encefalitida, žloutenka,
				cystická fibróza, celiakie a mnoho dalších dětských onemocnění.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Stanovení diagnózy závažného onemocnění dítěte nebo
				podstoupení některé z operací dle pojistných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši sjednané pojistné částky nebo
				její části, a to v závislosti na typu závažného onemocnění dítěte
				(procentuální hodnota pojistného plnění ve vztahu ke sjednané pojistné
				částce je uvedena v příloze pojistných podmínek). U závažného onemocnění
				/ operace s výplatou, 100 % pojistné částky, vyplatí pojišťovna současně
				s pojistným plněním také bonus ve výši 20 % pojistné částky sjednané na
				počátku tohoto připojištění jako příspěvek na ošetřování pojištěného
				dítěte.
			</p>
		</>
	),
	D018: (
		<>
			<h2>Kód pojistného krytí: D018</h2>
			<p>
				POPIS: Připojištění úrazu a trvalých následků úrazu dítěte poskytuje
				finanční pomoc v případě trvalého poškození po úrazu dítěte. Každý
				potřebuje mít pojištěny malé i velké úrazy, protože každý je denně
				vystaven mnoha rizikům. Od toho je zde právě připojištění trvalých
				následků s pojistným plněním od 1 % pojistné částky.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<p>a) Úraz uvedený v příloze pojistných podmínek;</p>
			<p>
				b) Úraz zanechávající trvalé následky uvedené v pojistných podmínkách,
				pokud jsou trvalé následky příslušným lékařem diagnostikovány do 3 let
				od úrazu;
			</p>
			<p>
				c) Hospitalizace v důsledku úrazu (musí trvat minimálně 8 po sobě
				následujících dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy úrazů/trvalých
				následků). Při hospitalizaci denní dávka sjednaná v příloze pojistných
				podmínek, a to za každý den hospitalizace (maximálně však 365 dní v
				rámci jedné pojistné události).
			</p>
		</>
	),
	"0001": (
		<>
			<h2>Kód pojistného krytí: 0001</h2>
			<p>
				POPIS: Připojištěním pro případ smrti se zvyšuje pojistné plnění pro
				případ smrti z jakékoliv příčiny (při pojistné události smrt se pak
				vyplácí pojistné plnění jak z hlavního krytí, tak i z tohoto
				připojištění).
			</p>
			<p>POJISTNÁ UDÁLOST: Smrt z jakékoliv příčiny.</p>
			<p>POJISTNÉ PLNĚNÍ: Pojistná částka platná k datu pojistné události.</p>
		</>
	),
	"0002": (
		<>
			<h2>0002 - Připojištění pro případ smrti úrazem</h2>
		</>
	),
	"0003": (
		<>
			<h2>0003 - Připojištění pro případ smrti úrazem</h2>
		</>
	),
	"0004": (
		<>
			<h2>Kód pojistného krytí: 0004</h2>
			<p>Název připojištění: Připojištění trvalých následků úrazu dítěte</p>
			<p>
				Popis připojištění: Připojištění trvalých následků úrazu dítěte
				poskytuje účinnou ochranu zaručující finanční odškodnění v případě
				trvalého poškození po úrazu dítěte. Každý z nás je denně vystaven mnoha
				rizikům, a proto potřebujeme mít pojištěny malé i velké úrazy. Právě od
				toho je zde připojištění trvalých následků úrazu dítěte.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz vymezený v pojistných podmínkách, v jehož
				důsledku dojde ke ztrátě tělesného orgánu nebo k úplné ztrátě jeho
				funkce v době do 3 let od data úrazu.
			</p>
		</>
	),
	"0005": (
		<>
			<h2>0005 - Připojištění trvalých následků úrazu</h2>
		</>
	),
	"0006": (
		<>
			<h2>Kód pojistného krytí: 0006</h2>
			<p>
				POPIS: Pojištění zajišťuje pojistníkovi prostředky na platbu pojistného
				(za všechna pojištění/připojištění na pojistné smlouvě) v případě, že by
				byl uznán invalidním 3. stupně (dříve plně invalidním). V takovém
				případě je pojistník zproštěn od povinnosti platit běžné pojistné
				(pojistné za pojistníka hradí pojišťovna). Pojistné krytí přitom zůstává
				tak, jak je.
			</p>
			<p>
				POJISTNÁ UDÁLOST: uznání 3. stupně invalidity (dříve plná invalidita –
				blíže viz pojistné podmínky)
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Zproštění pojistníka od povinnosti platit pojistné za
				hlavní krytí i veškerá připojištění sjednaná v pojistné smlouvě
				(pojistné za pojistníka hradí pojišťovna).
			</p>
		</>
	),
	"0007": (
		<>
			<h2>0007 - Připojištění trvalých následků úrazu dítěte</h2>
		</>
	),
	"0008": (
		<>
			<h2>0008 - Připojištění možnosti zvyšování pojistné částky</h2>
		</>
	),
	"000c": "-",
	"0011": (
		<>
			<h2>Kód pojistného krytí: 0011</h2>
			<p>Název připojištění: Připojištění pro případ smrti</p>
			<p>
				Popis připojištění: Připojištěním pro případ smrti se zvyšuje pojistné
				plnění pro případ smrti z jakékoliv příčiny (při pojistné události smrt
				se pak vyplácí pojistné plnění jak z hlavního krytí, tak i z tohoto
				připojištění).
			</p>
			<p>POJISTNÁ UDÁLOST: Smrt z jakékoliv příčiny.</p>
		</>
	),
	"0012": (
		<>
			<h2>Kód pojistného krytí: 0012</h2>
			<p> </p>
			<p>
				POPIS: Připojištěním pro případ smrti následkem úrazu se zvyšuje
				pojistné plnění pro případ smrti způsobené úrazem. Pokud k úrazu, jehož
				následkem pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse,
				vlaku, lodi, letadle, případně dalších dopravních prostředcích, zvyšuje
				se pojistné plnění o bonus dle pojistných podmínek.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Smrt úrazem, za předpokladu, že k úmrtí došlo do 3 let
				od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistná částka platná k datu pojistné události v
				případě smrti úrazem (+bonus v případě smrti při dopravní nehodě v autě,
				autobusu, vlaku, lodi, letadle, případně v dalších dopravních
				prostředcích dle pojistných podmínek).
			</p>
		</>
	),
	"0013": (
		<>
			<h2>Kód pojistného krytí: 0013</h2>
			<p>Název připojištění: Připojištění pro případ smrti následkem úrazu</p>
			<p>
				Popis připojištění: Připojištěním pro případ smrti následkem úrazu se
				zvyšuje pojistné plnění v případě smrti, pokud je způsobena úrazem.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Smrt následkem úrazu vymezeného v pojistných
				podmínkách v době do 3 let od data úrazu.
			</p>
		</>
	),
	"0014": (
		<>
			<h2>Kód pojistného krytí: 0014</h2>
			<p>
				POPIS: Připojištění pro případ smrti následkem úrazu a trvalých následků
				úrazu poskytuje pojistnou ochranu pro případ vybraných trvalých následků
				úrazu a současně též pro případ smrti způsobené úrazem.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Smrt následkem úrazu nebo trvalé následky způsobené
				úrazem (vždy jen došlo-li k úmrtí/trvalým následkům do tří let od data
				úrazu).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: V případě trvalých následků vyplatí pojišťovna
				příslušné procento z pojistné částky platné ke dni vzniku pojistné
				události (jak je toto procento uvedeno v příloze pojistných podmínek pro
				jednotlivé typy trvalých následků). V případě smrti následkem úrazu je
				vyplacena pojistná částka platná k datu pojistné události.
			</p>
		</>
	),
	"0015": (
		<>
			<h2>Kód pojistného krytí: 0015</h2>
			<p>
				Název připojištění: Připojištění pro případ smrti následkem úrazu a
				trvalých následků úrazu
			</p>
			<p>
				Popis připojištění: Připojištění pro případ smrti následkem úrazu a
				trvalých následků úrazu poskytuje ochranu pro případ vybraných trvalých
				následků úrazu a současně též pro případ smrti způsobené úrazem.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající do 3 let od svého vzniku trvalé
				následky uvedené v příloze pojistných podmínek nebo způsobující smrt
				pojištěného.
			</p>
		</>
	),
	CID6: (
		<>
			<h2>Kód pojistného krytí: CID6</h2>
			<p>
				POPIS: Připojištění pro případ invalidity poskytuje pojistnou ochranu
				pro případ invalidity 2. i 3. stupně a pojištěný se tak v těchto
				případech nemusí obávat o snížení svého životního standardu. Pojistné
				plnění z tohoto připojištění je vypláceno jednorázovou formou.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 2. nebo 3. stupeň invalidity. Pokles pracovní
				schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu musí být
				nejméně o 50 % (max. však o 69 %) u invalidity 2. stupně anebo nejméně o
				70 % u invalidity 3. stupně + příslušný stupeň invalidity musí být uznán
				v rámci posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 2. stupeň invalidity = 100 % aktuálně platné pojistné
				částky, 3. stupeň invalidity = 100 % aktuálně platné pojistné částky.
				Progrese ve výši 150 % = v případě 3. stupně invalidity a jedné z
				diagnóz – kvadruplegie nebo terminální onemocnění.
			</p>
		</>
	),
	CID7: (
		<>
			<h2>Kód pojistného krytí: CID7</h2>
			<p>
				POPIS: Připojištění pro případ invalidity poskytuje pojistnou ochranu
				pro případ invalidity 2. i 3. stupně a pojištěný se tak v těchto
				případech nemusí obávat o snížení svého životního standardu. Pojistné
				plnění z tohoto připojištění je vypláceno jednorázovou formou.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 2. nebo 3. stupeň invalidity. Pokles pracovní
				schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu musí být
				nejméně o 50 % (max. však o 69 %) u invalidity 2. stupně anebo nejméně o
				70 % u invalidity 3. stupně + příslušný stupeň invalidity musí být uznán
				v rámci posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 2. stupeň invalidity = 100 % aktuálně platné pojistné
				částky, 3. stupeň invalidity = 100 % aktuálně platné pojistné částky.
				Progrese ve výši 150 % = v případě 3. stupně invalidity a jedné z
				diagnóz – kvadruplegie nebo terminální onemocnění.
			</p>
		</>
	),
	CID8: (
		<>
			<h2>Kód pojistného krytí: CID8</h2>
			<p>
				POPIS: Připojištění pro případ invalidity s klesající pojistnou částkou
				poskytuje pojistnou ochranu pro případ invalidity 2. i 3. stupně a
				pojištěný se tak v těchto případech nemusí obávat o snížení svého
				životního standardu. Pojistné plnění z tohoto připojištění je vypláceno
				jednorázovou formou. Pojistná částka je u tohoto připojištění lineárně
				klesající a je tedy ke každému výročí snížena o 1/n sjednané pojistné
				částky, kde &quot;n&quot; představuje sjednanou pojistnou dobu v letech.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 2. nebo 3. stupeň invalidity. Pokles pracovní
				schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu musí být
				nejméně o 50 % (max. však o 69 %) u invalidity 2. stupně anebo nejméně o
				70 % u invalidity 3. stupně + příslušný stupeň invalidity musí být uznán
				v rámci posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 2. stupeň invalidity = 100 % aktuálně platné pojistné
				částky 3. stupeň invalidity = 100 % aktuálně platné pojistné částky.
				Progrese ve výši 150 % = v případě 3. stupně invalidity a jedné z
				diagnóz – kvadruplegie nebo terminální onemocnění.
			</p>
		</>
	),
	CIDA: (
		<>
			<h2>Kód pojistného krytí: CIDA</h2>
			<p>
				POPIS: Připojištění pro případ invalidity poskytuje pojistnou ochranu
				pro případ invalidity 1. stupně a pojištěný se tak v těchto případech
				nemusí obávat o snížení svého životního standardu. Pojistné plnění z
				tohoto připojištění je vypláceno jednorázovou formou.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 1. stupeň invalidity. Pokles pracovní schopnosti z
				důvodu dlouhodobě nepříznivého zdravotního stavu musí být nejméně o 35 %
				(max. však o 49 %) + příslušný stupeň invalidity musí být uznán v rámci
				posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 1. stupeň invalidity = 100 % aktuálně platné pojistné
				částky.
			</p>
		</>
	),
	CIDB: (
		<>
			<h2>Kód pojistného krytí: CIDB</h2>
			<p>
				POPIS: Připojištění pro případ invalidity poskytuje pojistnou ochranu
				pro případ invalidity 1. stupně a pojištěný se tak v těchto případech
				nemusí obávat o snížení svého životního standardu. Pojistné plnění z
				tohoto připojištění je vypláceno jednorázovou formou.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 1. stupeň invalidity. Pokles pracovní schopnosti z
				důvodu dlouhodobě nepříznivého zdravotního stavu musí být nejméně o 35 %
				(max. však o 49 %) + příslušný stupeň invalidity musí být uznán v rámci
				posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 1. stupeň invalidity = 100 % aktuálně platné pojistné
				částky.
			</p>
		</>
	),
	CIDC: (
		<>
			<h2>Kód pojistného krytí: CIDC</h2>
			<p>
				POPIS: Připojištění pro případ invalidity s klesající pojistnou částkou
				poskytuje pojistnou ochranu pro případ invalidity 1. stupně a pojištěný
				se tak v těchto případech nemusí obávat o snížení svého životního
				standardu. Pojistné plnění z tohoto připojištění je vypláceno
				jednorázovou formou. Pojistná částka je u tohoto připojištění lineárně
				klesající a je tedy ke každému výročí snížena o 1/n sjednané pojistné
				částky, kde &quot;n&quot; představuje sjednanou pojistnou dobu v letech.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 1. stupeň invalidity. Pokles pracovní schopnosti z
				důvodu dlouhodobě nepříznivého zdravotního stavu musí být nejméně o 35 %
				(max. však o 49 %) + příslušný stupeň invalidity musí být uznán v rámci
				posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 1. stupeň invalidity = 100 % aktuálně platné pojistné
				částky.
			</p>
		</>
	),
	CDI2: (
		<>
			<h2>Kód pojistného krytí: CDI2</h2>
			<p>
				POPIS: Připojištění pro případ závislosti dítěte na péči poskytuje
				pojistnou ochranu pro případ, kdy dítě není schopno z důvodu dlouhodobě
				nepříznivého zdravotního stavu samostatně zvládat 6 až 9 vyjmenovaných
				životních potřeb a vyžaduje každodenní mimořádnou péči jiné fyzické
				osoby. Pojistné plnění z tohoto připojištění je vypláceno jednorázovou
				formou.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 3., nebo 4. stupeň závislosti pojištěného dítěte na
				pomoci jiné osoby. Závislost pojištěného dítěte na péči jiné osoby musí
				být pojišťovně doložena úředně ověřenou kopií rozhodnutí orgánu
				vykonávajícího působnost v oblasti sociálních služeb.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 3. stupeň závislosti = 100 % aktuálně platné pojistné
				částky 4. stupeň závislosti = 100 % aktuálně platné pojistné částky.
			</p>
		</>
	),
	CDN2: (
		<>
			<h2>Kód pojistného krytí: CDN2</h2>
			<p>
				POPIS: Připojištění pro případ vybraných onemocnění dětí poskytuje
				pojistnou ochranu pro případ více než 100 diagnóz.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Onemocnění dítěte uvedené v tabulce, která je součástí
				zvláštních pojistných podmínek tohoto připojištění.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Jednorázové plnění odpovídající pojistné částce uvedené
				pro dané onemocnění a sjednaný násobek pojistné částky v příslušné
				tabulce přílohy, která je součástí zvláštních pojistných podmínek tohoto
				připojištění.
			</p>
		</>
	),
	CAS4: (
		<>
			<h2>Kód pojistného krytí: CAS4</h2>
			<p>
				POPIS: Připojištění asistenčních služeb Vám pomůže v případě, že se
				ocitnete v neočekávané situaci a potřebujete s daným problémem okamžitě
				pomoci.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Asistenční událost, čili úraz nebo nemoc, které
				vyžádají asistenční plnění (finanční i nefinační) z jednotlivých služeb
				vydefinovaných v tabulce, která je součástí zvláštních pojistných
				podmínek tohoto připojištění. Jedná se například o telefonickou linku
				zdravotních informací, konzultaci zdravotního stavu, dovoz léků
				předepsaných pojištěnému, dopravu z nemocnice po hospitalizaci a další.
				Pojistná událost se hlásí asistenční společnosti AXA ASSISTANCE CZ, s.
				r. o..
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Zahrnuje zejména poskytnutí asistenční služby a úplaty
				externím dodavatelům daných služeb asistenční společností AXA ASSISTANCE
				CZ, s. r. o..
			</p>
		</>
	),
	CPN5: (
		<>
			<h2>Kód pojistného krytí: CPN5</h2>
			<p>
				POPIS: Připojištění pro případ pracovní neschopnosti zajišťuje finanční
				pomoc v případě, kdy pojištěný nemůže podle lékařského rozhodnutí žádným
				způsobem vykonávat a nevykonává své zaměstnání nebo svou samostatnou
				výdělečnou činnost.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost pojištěného
				(podmínkou je trvání pracovní neschopnosti minimálně 29 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka od 29. dne lékařem přiznané
				pracovní neschopnosti (max. však ve výši odpovídající skutečné ztrátě na
				výdělku pojištěného; tento limit neplatí, pokud sjednaná denní dávka
				nepřesahuje maximální sjednanou denní dávku stanovenou pojišťovnou, u
				které se příjem pojištěného nezkoumá). Maximální délka denní dávky je
				365 dní (u vybraných diagnoz může být maximální doba plnění kratší).
			</p>
		</>
	),
	CPN6: (
		<>
			<h2>Kód pojistného krytí: CPN6</h2>
			<p>
				POPIS: Připojištění pro případ pracovní neschopnosti zajišťuje finanční
				pomoc v případě, kdy pojištěný nemůže podle lékařského rozhodnutí žádným
				způsobem vykonávat a nevykonává své zaměstnání nebo svou samostatnou
				výdělečnou činnost.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost pojištěného
				(podmínkou je trvání pracovní neschopnosti minimálně 29 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka od 29. dne lékařem přiznané
				pracovní neschopnosti (max. však ve výši odpovídající skutečné ztrátě na
				výdělku pojištěného; tento limit neplatí, pokud sjednaná denní dávka
				nepřesahuje maximální sjednanou denní dávku stanovenou pojišťovnou, u
				které se příjem pojištěného nezkoumá). Maximální délka denní dávky je
				365 dní (u vybraných diagnoz může být maximální doba plnění kratší).
			</p>
		</>
	),
	CUD3: (
		<>
			<h2>Kód pojistného krytí: CUD3</h2>
			<p>
				POPIS: Připojištění pro případ invalidního důchodu následkem úrazu s
				výplatou renty poskytuje pojistnou ochranu pro případ invalidity 3.
				stupně způsobené úrazem a pojištěný se tak v těchto případech nemusí
				obávat o snížení svého životního standardu. Pojistné plnění z tohoto
				připojištění je formou měsíční výplaty.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 3. stupeň invalidity následkem úrazu. Pokles pracovní
				schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu musí být
				nejméně o 70 % + 3. stupeň invalidity musí být uznán v rámci posudku
				příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve formě renty, která se vyplácí v
				pravidelných měsíčních dávkách ve výši 1/12 pojistné částky platné ke
				dni vzniku pojistné události. Po zahájení výplaty renty se vždy k
				výročnímu dni počátku připojištění roční hodnota renty navýší o 5 % (z
				pojistné částky platné ke dni vzniku pojistné události). Za určitých
				podmínek bude pojišťovna pokračovat s výplatou renty i po zániku tohoto
				připojištění až do dosažení věku 65 let pojištěného.
			</p>
		</>
	),
	CID5: (
		<>
			<h2>Kód pojistného krytí: CID5</h2>
			<p>
				POPIS: Připojištění pro případ invalidního důchodu s klesající pojistnou
				částkou poskytuje komplexní pojistnou ochranu pro případ invalidity (1.,
				2. i 3. stupně) a pojištěný se tak v těchto případech nemusí se obávat o
				snížení svého životního standardu. Pojistné plnění z tohoto připojištění
				je jednorázovou formou. Pojistná částka je u tohoto připojištění
				lineárně klesající a je tedy ke každému výročí snížena o 1/n sjednané
				pojistné částky, kde &quot;n&quot; představuje sjednanou pojistnou dobu
				v letech.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 1., 2. nebo 3. stupeň invalidity. Pokles pracovní
				schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu musí být
				nejméně o 35 % (max. však o 49 %) u invalidity 1. stupně, nejméně o 50 %
				(max. však o 69 %) u invalidity 2. stupně anebo nejméně o 70 % u
				invalidity 3. stupně + příslušný stupeň invalidity musí být uznán v
				rámci posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<p>1. stupeň invalidity = 20 % aktuálně platné pojistné částky</p>
			<p>2. stupeň invalidity = 100 % aktuálně platné pojistné částky</p>
			<p>3. stupeň invalidity = 100 % aktuálně platné pojistné částky.</p>
			<p>
				Progrese ve výši 150 % = v případě 3. stupně invalidity a jedné z
				diagnóz – kvadruplegie nebo terminální onemocnění.
			</p>
		</>
	),
	CZV5: (
		<>
			<h2>Kód pojistného krytí: CZV5</h2>
			<p>
				POPIS: Připojištění pro případ závažných onemocnění dospělých s
				klesající pojistnou částkou zajišťuje finanční pomoc v případě, kdy
				pojištěného postihne některé z terminálních nebo závažných onemocnění
				(srdeční infarkt, mrtvice, rakovina, selhání ledvin, transplantace
				životně důležitých orgánů, náhrada srdeční chlopně, operace aorty, AIDS,
				HIV infekce, oslepnutí, ztráta sluchu, operace věnčitých tepen – bypass,
				onemocnění plic způsobující dechovou nedostatečnost, nitrolební nádory
				nezhoubného původu, roztroušená skleróza, encefalitida nebo žloutenka a
				mnoho dalších). Pojistná částka je u tohoto připojištění lineárně
				klesající a je tedy ke každému výročí snížena o 1/n sjednané pojistné
				částky, kde &quot;n&quot; představuje sjednanou pojistnou dobu v letech.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Stanovení diagnózy závažného onemocnění anebo
				podstoupení některé z operací dle pojistných podmínek (s bonusem 50 %
				pojistné částky v případě diagnózy terminální fáze rakoviny).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši aktuálně platné pojistné částky
				nebo její části, a to v závislosti na typu závažného onemocnění
				(procentuální hodnota pojistného plnění ve vztahu k pojistné částce je
				uvedena v příloze pojistných podmínek).
			</p>
		</>
	),
	CZR5: (
		<>
			<h2>Kód pojistného krytí: CZR5</h2>
			<p>
				POPIS: Připojištění pro případ rakoviny dospělých s klesající pojistnou
				částkou poskytuje účinnou pojistnou ochranu v případě, že Vás v průběhu
				života postihne toto závažné onemocnění. Pojistná částka je u tohoto
				připojištění lineárně klesající a je tedy ke každému výročí snížena o
				1/n sjednané pojistné částky, kde &quot;n&quot; představuje sjednanou
				pojistnou dobu v letech.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Stanovení diagnózy rakoviny, terminální fáze rakoviny
				(s bonusem 50 % pojistné částky) a/nebo diagnózy tzv. rakoviny in situ.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši aktuálně platné pojistné částky
				nebo její části, a to v závislosti na typu diagnózy (procentuální
				hodnota pojistného plnění ve vztahu k pojistné částce je uvedena v
				příloze pojistných podmínek).
			</p>
		</>
	),
	RZ2C: (
		<>
			<h2>Kód pojistného krytí: RZ2C</h2>
			<p>
				POPIS: Životní pojištění NN Život je produkt pro Váš aktivní život,
				kterým pojistíte sebe i své blízké. Jeho výhodou je velká flexibilita,
				díky které můžete pojištění v průběhu přizpůsobovat Vaší aktuální
				životní situaci, svým potřebám a možnostem. Obsahuje navíc bonus
				zvyšující pojistné plnění v případě, že k úrazu, jehož následkem
				pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse, vlaku,
				lodi, letadle, případně dalších dopravních prostředcích.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<p>a) Smrt 1. pojištěného z jakékoliv příčiny.</p>
			<p>b) Smrt 2. pojištěného z jakékoliv příčiny (viz kód R22C).</p>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<p>
				a) V případě smrti 1. pojištěného pojistné plnění ve výši sjednané
				pojistné částky pro 1. pojištěného.
			</p>
			<p>
				b) V případě smrti 2. pojištěného pojistné plnění ve výši sjednané
				pojistné částky pro 2. pojištěného. Pokud k úrazu, jehož následkem 1.
				nebo 2. pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse,
				vlaku, lodi, letadle, případně dalších dopravních prostředcích dle
				pojistných podmínek, vyplatí pojišťovna navíc bonus ve výši uvedené v
				pojistné smlouvě.
			</p>
		</>
	),
	RM1C: (
		<>
			<h2>Kód pojistného krytí: RM1C</h2>
			<p>
				POPIS: Životní pojištění NN Život je produkt pro Váš aktivní život,
				kterým pojistíte sebe i své blízké. Jeho výhodou je velká flexibilita,
				díky které můžete pojištění v průběhu přizpůsobovat Vaší aktuální
				životní situaci, svým potřebám a možnostem. Obsahuje navíc bonus
				zvyšující pojistné plnění v případě, že k úrazu, jehož následkem
				pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse, vlaku,
				lodi, letadle, případně dalších dopravních prostředcích.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<p>a) Smrt 1. pojištěného z jakékoliv příčiny.</p>
			<p>b) Smrt 2. pojištěného z jakékoliv příčiny (viz kód R22C).</p>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<p>
				a) V případě smrti 1. pojištěného pojistné plnění ve výši sjednané
				pojistné částky pro 1. pojištěného.
			</p>
			<p>
				b) V případě smrti 2. pojištěného pojistné plnění ve výši sjednané
				pojistné částky pro 2. pojištěného. Pokud k úrazu, jehož následkem 1.
				nebo 2. pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse,
				vlaku, lodi, letadle, případně dalších dopravních prostředcích dle
				pojistných podmínek, vyplatí pojišťovna navíc bonus ve výši uvedené v
				pojistné smlouvě.
			</p>
		</>
	),
	R22C: (
		<>
			<h2>Kód pojistného krytí: R22C</h2>
			<p>
				POPIS: Hlavní krytí pro 2. pojištěného - Životní pojištění NN Život.
			</p>
		</>
	),
	A510: (
		<>
			<h2>Kód pojistného krytí: A510</h2>
			<p>
				Investiční životní pojištění Garance Plus je určené klientům, kteří
				hledají prvky pojistné ochrany a zhodnocování volných finančních
				prostředků prostřednictívm investice na 5 let. Při splatnosti se vyplácí
				investorům celá počáteční hodnota investice a potenciální výnos.
			</p>
		</>
	),
	ACF4: (
		<>
			<h2>ACF4 - Pripoistenie detí v rodine</h2>
		</>
	),
	ACR0: (
		<>
			<h2>ACR0 - Pripoistenie následkov úrazu dieťaťa</h2>
		</>
	),
	ACR1: (
		<>
			<h2>ACR1 - Pripoistenie detí v rodine</h2>
		</>
	),
	ACR2: (
		<>
			<h2>ACR2 - Pripoistenie detí v rodine</h2>
		</>
	),
	ACR3: (
		<>
			<h2>ACR3 - Základné pripoistenie detí v rodine</h2>
		</>
	),
	ACR4: (
		<>
			<h2>ACR4 - Pripoistenie detí v rodine</h2>
		</>
	),
	ACR5: (
		<>
			<h2>ACR5 - Pripoistenie následkov úrazu dieťaťa</h2>
		</>
	),
	ACR6: (
		<>
			<h2>ACR6 - Pripoistenie následkov úrazu dieťaťa</h2>
		</>
	),
	ACR8: "-",
	ACR9: (
		<>
			<h2>ACR9 - Následok úrazu dieťaťa poisteného</h2>
		</>
	),
	ADA2: "-",
	ADAR: (
		<>
			<h2>ADAR - Pripoistenie invalidného dôchodku z úrazu</h2>
		</>
	),
	ADR0: (
		<>
			<h2>ADR0 - Pripoistenie smrteľného úrazu</h2>
		</>
	),
	ADR1: (
		<>
			<h2>ADR1 - Pripoistenie smrteľného úrazu</h2>
		</>
	),
	ADR3: "-",
	B001: (
		<>
			<h2>Kód pojistného krytí: B001</h2>
			<p>Název připojištění: Připojištění pro případ smrti</p>
			<p>
				Popis připojištění: Připojištěním pro případ smrti se zvyšuje pojistné
				plnění pro případ smrti z jakékoliv příčiny (při pojistné události smrt
				se pak vyplácí pojistné plnění jak z hlavního krytí, tak i z tohoto
				připojištění).
			</p>
			<p>POJISTNÁ UDÁLOST: Smrt z jakékoliv příčiny.</p>
		</>
	),
	B012: (
		<>
			<h2>Kód pojistného krytí: B012</h2>
			<p>Název připojištění: Připojištění pro případ smrti následkem úrazu</p>
			<p>
				Popis připojištění: Připojištěním pro případ smrti následkem úrazu se
				zvyšuje pojistné plnění v případě smrti, pokud je způsobena úrazem.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Smrt následkem úrazu vymezeného v pojistných
				podmínkách v době do 3 let od data úrazu.
			</p>
		</>
	),
	B150: (
		<>
			<h2>B150 - Životní pojištění Investor Plus</h2>
		</>
	),
	B250: (
		<>
			<h2>B250 - Investiční životní pojištění NN Investor</h2>
		</>
	),
	B2J0: (
		<>
			<h2>B2J0 - Pojištění NN Investor Junior</h2>
		</>
	),
	B350: (
		<>
			<h2>B350 - Investor Exclusive</h2>
		</>
	),
	B450: (
		<>
			<h2>B450 - ZFP Život</h2>
		</>
	),
	B550: (
		<>
			<h2>B550 - ZFP Život</h2>
		</>
	),
	CAS0: (
		<>
			<h2>Kód pojistného krytí: CAS0</h2>
			<p>Název připojištění: Připojištění asistenčních služeb</p>
			<p>
				Popis připojištění: Připojištění asistenčních služeb zajišťuje
				pojištěnému jak zdravotnickou, tak domácí asistenci (jako např. odvoz na
				ošetření k lékaři, dovoz z nemocnice po hospitalizaci, dovoz léků či
				úklid domácnosti) zejména při řešení každodenních starostí spojených s
				péčí o domácnost tak, aby se pojištěný mohl naplno věnovat jen svému
				zdraví.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Asistenční událost, ke které dojde v přímé souvislosti
				s úrazem nebo nemocí pojištěného po uplynutí stanovené doby, a se kterou
				je na základě pojistných podmínek spojena povinnost asistenční
				společnosti poskytovat asistenční plnění.
			</p>
		</>
	),
	CAS1: (
		<>
			<h2>Kód pojistného krytí: CAS1</h2>
			<p>Název připojištění: Připojištění asistenčních služeb</p>
			<p>
				Popis připojištění: Připojištění asistenčních služeb si klade za cíl
				pomoct při řešení každodenních starostí spojených s péčí o domácnost
				tak, aby se pojištěná mohla naplno věnovat jen svému zdraví. V rámci
				širokého spektra nabízených asistenčních služeb jej lze využít např. k
				vyzvednutí dětí ze školy nebo k zajištění nákupu, ale zrovna tak na
				odbornou psychologickou pomoc.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Asistenční událost, kterou se rozumí nahodilá událost
				spočívající ve zhoršeném zdravotním stavu pojištěného, se kterou je na
				základě pojistných podmínek spojena povinnost asistenční společnosti
				poskytovat pojištěnému asistenční plnění, a ke které dojde po uplynutí
				čekací doby stanovené v pojistných podmínkách.
			</p>
		</>
	),
	CAS3: (
		<>
			<h2>Kód pojistného krytí: CAS3</h2>
			<p>Název připojištění: Připojištění asistenčních služeb</p>
			<p>
				Popis připojištění: Připojištění asistenčních služeb zajišťuje
				pojištěnému jak zdravotnickou, tak domácí asistenci (jako např. odvoz na
				ošetření k lékaři, dovoz z nemocnice po hospitalizaci, dovoz léků či
				úklid domácnosti) zejména při řešení každodenních starostí spojených s
				péčí o domácnost tak, aby se pojištěný mohl naplno věnovat jen svému
				zdraví.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Asistenční událost, ke které dojde v přímé souvislosti
				s úrazem nebo nemocí pojištěného po uplynutí stanovené doby, a se kterou
				je spojena povinnost asistenční společnosti poskytovat asistenční
				plnění.
			</p>
		</>
	),
	CDU3: (
		<>
			<h2>Kód pojistného krytí: CDU3</h2>
			<p>Název připojištění: Připojištění pro případ následků úrazu</p>
			<p>
				Popis připojištění: Připojištění pro případ následků úrazu poskytuje
				ochranu pro případ vybraných následků úrazu a v těchto případech
				zaručuje jednoduchou a rychlou pomoc. Každá diagnóza je ohodnocena
				pevnou částkou pojistného plnění.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Následky úrazu pojištěného uvedené v příloze
				pojistných podmínek.
			</p>
		</>
	),
	CFR1: (
		<>
			<h2>Kód pojistného krytí: CFR1</h2>
			<p>
				Název připojištění: Připojištění pro případ rakoviny prsu a ženských
				pohlavních orgánů
			</p>
			<p>
				Popis připojištění: Připojištění pro případ rakoviny prsu a ženských
				pohlavních orgánů poskytuje finanční pomoc v případě diagnózy vybraných
				onemocnění (rakovina prsu, vaječníků, vulvy, zhoubné nádory dělohy atd.)
				tak, aby pojištěná mohla soustředit veškerou svou energii jen na
				vyléčení diagnostikované nemoci a mohla si dopřát nadstandardní péči
				např. v podobě léčby v zahraničí.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Stanovení diagnózy některého z druhů rakoviny
				vymezených v příloze pojistných podmínek po uplynutí čekací doby.
			</p>
		</>
	),
	CH02: (
		<>
			<h2>CH02 - Připojištění denní dávky při pobytu v nemocnici </h2>
		</>
	),
	CHO1: (
		<>
			<h2>Kód pojistného krytí: CHO1</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici poskytuje
				pojistnou ochranu pro případ hospitalizace. Díky těmto finančním
				prostředkům si můžete zajistit nadstandardní nemocniční péči, sjednat
				pomoc v domácnosti v době své nepřítomnosti nebo pomoci své rodině s
				cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>POJISTNÁ UDÁLOST: Hospitalizace (musí trvat minimálně 24 hodin).</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	CHO2: (
		<>
			<h2>Kód pojistného krytí: CHO2</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu dítěte v nemocnici poskytuje
				pojistnou ochranu pro případ hospitalizace. Díky těmto finančním
				prostředkům můžete zajistit dítěti nadstandardní nemocniční péči,
				sjednat pomoc v domácnosti v době své nepřítomnosti nebo pomoci své
				rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace dítěte (musí trvat minimálně 24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace
				dítěte. Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	CHO3: (
		<>
			<h2>Kód pojistného krytí: CHO3</h2>
			<p>Název připojištění: Připojištění hospitalizace</p>
			<p>
				Popis připojištění: Připojištění denní dávky při pobytu v nemocnici
				poskytuje ochranu pro případ hospitalizace. Díky těmto finančním
				prostředkům si můžete zajistit nadstandardní nemocniční péči, sjednat
				pomoc v domácnosti v době své nepřítomnosti nebo pomoci své rodině s
				cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace pojištěného trvající minimálně 7 po sobě
				následujících kalendářních dnů.
			</p>
		</>
	),
	CHU1: (
		<>
			<h2>Kód pojistného krytí: CHU1</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici následkem úrazu
				poskytuje pojistnou ochranu pro případ hospitalizace. Díky těmto
				finančním prostředkům si můžete zajistit nadstandardní nemocniční péči,
				sjednat pomoc v domácnosti v době své nepřítomnosti nebo pomoci své
				rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace v důsledku úrazu (musí trvat minimálně
				24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	CHU2: (
		<>
			<h2>Kód pojistného krytí: CHU2</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu dítěte v nemocnici následkem
				úrazu poskytuje pojistnou ochranu pro případ hospitalizace dítěte
				následkem úrazu. Díky těmto finančním prostředkům si můžete zajistit
				nadstandardní nemocniční péči, sjednat pomoc v domácnosti v době své
				nepřítomnosti nebo pomoci své rodině s cestovními náklady při návštěvách
				v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace dítěte v důsledku úrazu (musí trvat
				minimálně 24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	CHU3: (
		<>
			<h2>Kód pojistného krytí: CHU3</h2>
			<p>Název připojištění: Připojištění poúrazové hospitalizace</p>
			<p>
				Popis připojištění: Připojištění denní dávky při pobytu v nemocnici
				poskytuje ochranu pro případ hospitalizace v důsledku utrpěného úrazu.
				Díky těmto finančním prostředkům si můžete zajistit nadstandardní
				nemocniční péči, sjednat pomoc v domácnosti v době své nepřítomnosti
				nebo pomoci své rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace pojištěného v důsledku úrazu trvající
				minimálně 7 po sobě následujících kalendářních dnů, pokud k
				hospitalizaci dojde nejpozději do 3 let od takového úrazu.
			</p>
		</>
	),
	CHUF: (
		<>
			<h2>Kód pojistného krytí: CHUF</h2>
			<p>
				POPIS: Připojištění pro případ hospitalizace následkem úrazu dítěte
				zajistí finanční prostředky, díky nimž můžete Vašemu dítěti zařídit
				nadstandardní nemocniční péči, sjednat pomoc v domácnosti v době své
				nepřítomnosti nebo pomoci své rodině s cestovními náklady při návštěvách
				v nemocnici, je-li dítě hospitalizováno v důsledku úrazu. Pro toto
				připojištění platí pojistné podmínky produktu CHU2.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace dítěte v důsledku úrazu (musí trvat
				minimálně 24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	"0017": (
		<>
			<h2>Kód pojistného krytí: 0017</h2>
			<p>Název připojištění: Připojištění trvalých následků úrazu dítěte</p>
			<p>
				Popis připojištění: Připojištění trvalých následků úrazu dítěte
				poskytuje účinnou ochranu zaručující finanční odškodnění v případě
				trvalého poškození po úrazu dítěte. Každý z nás je denně vystaven mnoha
				rizikům, a proto potřebujeme mít pojištěny malé i velké úrazy. Právě od
				toho je zde připojištění trvalých následků úrazu dítěte.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající do 3 let od svého vzniku trvalé
				následky uvedené v příloze pojistných podmínek.
			</p>
		</>
	),
	"0018": (
		<>
			<h2>Kód pojistného krytí: 0018</h2>
			<p>
				Název připojištění: Připojištění úrazu a trvalých následků úrazu dítěte
			</p>
			<p>
				Popis připojištění: Připojištění úrazu a trvalých následků úrazu dítěte
				poskytuje finanční pomoc v případě trvalého poškození po úrazu dítěte.
				Každý z nás je denně vystaven mnoha rizikům, a proto potřebujeme mít
				pojištěny malé i velké úrazy. Od toho je zde právě připojištění úrazů a
				jejich trvalých následků s pojistným plněním od 1 % pojistné částky.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<ol type="a">
					<li>Úraz uvedený v příloze pojistných podmínek;</li>
					<li>
						trvalé následky úrazu uvedené v příloze pojistných podmínek nastalé
						do 3 let od data úrazu;
					</li>
					<li>
						hospitalizace v důsledku úrazu (musí trvat minimálně 8 po sobě
						následujících dní).
					</li>
				</ol>
			</p>
		</>
	),
	"0019": (
		<>
			<h2>Kód pojistného krytí: 0019</h2>
			<p>
				Název připojištění: Připojištění pro případ smrti následkem úrazu,
				trvalých následků úrazu a pro případ plné invalidity následkem úrazu
			</p>
			<p>
				Popis připojištění: Připojištění pro případ smrti následkem úrazu,
				trvalých následků úrazu a pro případ 3. stupně invalidity (dříve plná
				invalidita) poskytuje ochranu pro případ pro případ smrti pojištěného
				způsobenou úrazem, vybraných trvalých následků úrazu a současně též
				ochranu v případech, kdy se vlivem úrazu pojištěný stane invalidním.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<ol type="a">
					<li>smrt pojištěného v důsledku úrazu do 3 let od data úrazu;</li>
					<li>
						trvalé následky úrazu vymezené v pojistných podmínkách nastalé do 3
						let od data úrazu; a
					</li>
					<li>
						uznání 3. stupně invalidity (dříve plná invalidita) v důsledku úrazu
						do 1 roku od data úrazu.
					</li>
				</ol>
			</p>
		</>
	),
	"0020": (
		<>
			<h2>0020 - Připojištění dočasného důchodu pro případ plné invalidity</h2>
		</>
	),
	"0021": (
		<>
			<h2>0021 - Připojištění dočasného důchodu pro případ plné invalidity</h2>
		</>
	),
	"0022": (
		<>
			<h2>0022 - Připojištění dočasného důchodu pro případ plné invalidity</h2>
		</>
	),
	"0023": (
		<>
			<h2>Kód pojistného krytí: 0023</h2>
			<p>
				Název připojištění: Připojištění pro případ plného invalidního důchodu
				následkem úrazu
			</p>
			<p>
				Popis připojištění: Připojištění pro případ 3. stupně invalidity (dříve
				plná invalidita) následkem úrazu poskytuje ochranu v případech, kdy se
				vlivem úrazu pojištěný stane invalidním, výrazně poklesne jeho schopnost
				soustavné výdělečné činnosti nebo je soustavné výdělečné činnosti
				schopen jen za zcela mimořádných podmínek. Díky tomuto připojištění se
				právě v těchto případech pojištěný nemusí obávat snížení svého životního
				standardu.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Uznání 3. stupně invalidity (dříve plná invalidita)
				následkem úrazu vymezeného v pojistných podmínkách, jestliže následně z
				důvodu dlouhodobě nepříznivého zdravotního stavu pojištěného došlo k
				poklesu jeho schopnosti soustavné výdělečné činnosti o stanovené
				procento nebo pro zdravotní postižení je schopen soustavné výdělečné
				činnosti jen za zcela mimořádných podmínek.
			</p>
		</>
	),
	"0024": (
		<>
			<h2>Kód pojistného krytí: 0024</h2>
			<p>
				POPIS: Připojištění pro případ plného invalidního důchodu následkem
				úrazu poskytuje pojistnou ochranu pro případ plné invalidity (dnes
				invalidita 3. stupně) způsobené úrazem a pojištěný se tak v těchto
				případech nemusí se obávat o snížení svého životního standardu.
			</p>
			<p>POJISTNÁ UDÁLOST: </p>
			<p>
				a) uznání 3. stupně invalidity (dříve plná invalidita) následkem úrazu
				pojišťovnou, jestliže z důvodu dlouhodobě nepříznivého zdravotního stavu
				došlo k poklesu schopnosti soustavné výdělečné činnosti nejméně o 66 % a
				pojištěný žádnou soustavnou výdělečnou činnost neprovozuje, nebo pro
				zdravotní postižení je schopen soustavné výdělečné činnosti jen za zcela
				mimořádných podmínek.
			</p>
			<p>
				b) dožití se sjednaného konce připojištění nebo zániku připojištění
				přiznáním starobního důchodu či dosažením věku 65 let, není-li uplatněna
				pojistná událost ad a)
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Při pojistné události ad a) pojistné plnění ve formě
				důchodu, který se vyplácí v pravidelných měsíčních dávkách ve výši 1/12
				pojistné částky platné ke dni vzniku pojistné události. Důchod bude
				vyplácen ode dne pojistné události, nejdříve však po uplynutí 6 měsíců
				od úrazu, v jehož důsledku pojistná událost nastala. V době výplaty
				důchodu pojišťovna k výročnímu dni počátku připojištění zvýší roční
				hodnotu důchodu o 5 % z pojistné částky platné ke dni pojistné události.
				Dnem konce připojištění končí výplata důchodu a připojištění zaniká. Při
				pojistné události ad b) 50 % z celkově zaplaceného pojistného za toto
				připojištění, splatného od výročního dne počátku připojištění, který
				následuje po datu 1. 8. 2004.
			</p>
		</>
	),
	"0026": (
		<>
			<h2>Kód pojistného krytí: 0026</h2>
			<p>
				POPIS: Připojištění pro případ úrazu a trvalých následků úrazu poskytuje
				pojistnou ochranu pro případ vybraných úrazů bez trvalých následků
				(zejména zlomenin), vybraných trvalých následků úrazu a současně též pro
				případ hospitalizace následkem úrazu a zaručuje jednoduchou a rychlou
				pomoc. Každá diagnóza je ohodnocena pevnou částkou pojistného plnění.
			</p>
			<p>
				POJISTNÁ UDÁLOST: a) Úraz uvedený v příloze pojistných podmínek; b) Úraz
				zanechávající trvalé následky uvedené v pojistných podmínkách, pokud
				jsou trvalé následky příslušným lékařem diagnostikovány do 3 let od
				úrazu; c) Hospitalizace v důsledku úrazu (musí trvat alespoň 24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši uvedené pro daný úraz / trvalé
				následky v příloze pojistných podmínek. Při hospitalizaci denní dávka
				sjednaná v příloze pojistných podmínek, a to za každý den hospitalizace
				(maximálně však 52 týdnů v rámci jedné pojistné události).
			</p>
		</>
	),
	"0027": (
		<>
			<h2>Kód pojistného krytí: 0027</h2>
			<p>
				Název připojištění: Doplňkové připojištění pro případ úrazu a trvalých
				následků úrazuPopis připojištění: Připojištění pro případ úrazu a
				trvalých následků úrazu poskytuje ochranu pro případ vybraných úrazů bez
				trvalých následků (zejména zlomenin), vybraných trvalých následků úrazů
				a současně též pro případ hospitalizace následkem úrazu a pro tyto
				případy zaručuje jednoduchou a rychlou pomoc. Každá diagnóza je
				ohodnocena pevnou částkou pojistného plnění.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<ol type="a">
					<li>Úraz uvedený v příloze pojistných podmínek;</li>
					<li>
						Úraz zanechávající do 3 let od svého vzniku trvalé následky uvedené
						v příloze pojistných podmínek;
					</li>
					<li>
						Hospitalizace v důsledku úrazu (musí trvat minimálně 11 po sobě
						následujících dní).
					</li>
				</ol>
			</p>
		</>
	),
	"0028": (
		<>
			<h2>Kód pojistného krytí: 0028</h2>
			<p>
				POPIS: Připojištění pro případ plného invalidního důchodu následkem
				úrazu poskytuje pojistnou ochranu pro případ invalidity 3. stupně (plné
				invalidity) způsobené úrazem a pojištěný se tak v těchto případech
				nemusí se obávat o snížení svého životního standardu.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Uznání 3. stupně invalidity (dříve plná invalidita)
				následkem úrazu pojišťovnou, jestliže z důvodu dlouhodobě nepříznivého
				zdravotního stavu došlo k poklesu schopnosti soustavné výdělečné
				činnosti nejméně o 66 % a pojištěný žádnou soustavnou výdělečnou činnost
				neprovozuje nebo pro zdravotní postižení je schopen soustavné výdělečné
				činnosti jen za zcela mimořádných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve formě důchodu, který se vyplácí v
				pravidelných měsíčních dávkách ve výši 1/12 pojistné částky platné ke
				dni vzniku pojistné události. Důchod bude vyplácen ode dne pojistné
				události, nejdříve však po uplynutí 6 měsíců od úrazu, v jehož důsledku
				pojistná událost nastala. V době výplaty důchodu pojišťovna k výročnímu
				dni počátku připojištění zvýší roční hodnotu důchodu o 5 % z pojistné
				částky platné ke dni pojistné události. Dnem konce připojištění končí
				výplata důchodu a připojištění zaniká.
			</p>
		</>
	),
	"0030": (
		<>
			<h2>Kód pojistného krytí: 0030</h2>
			<p>
				POPIS: Připojištění pro případ úrazu poskytuje účinnou pojistnou
				ochranu, která je určena na krytí drobných i větších úrazů, zejména
				hlavy, krku, hrudníku, břicha, horních a dolních končetin, ale i dalších
				částí těla.
			</p>
			<p>POJISTNÁ UDÁLOST: Úraz uvedený v příloze pojistných podmínek.</p>
			<p>
				POJISTNÉ PLNĚNÍ: Ve výši příslušného procenta pojistné částky platné k
				datu pojistné události (jak je toto procento uvedeno v příloze
				pojistných podmínek pro jednotlivé typy úrazů).
			</p>
		</>
	),
	"0031": (
		<>
			<h2>0031 - Připojištění závažných onemocnění</h2>
		</>
	),
	"0032": (
		<>
			<h2>Kód pojistného krytí: 0032</h2>
			<p>Název připojištění: Připojištění pro případ závažných onemocnění</p>
			<p>
				Popis připojištění: Připojištění pro případ závažných onemocnění
				poskytuje účinnou ochranu pro případ, kdy pojištěného postihne některé
				ze závažných onemocnění, jako je např. srdeční infarkt, mrtvice,
				rakovina, selhání ledvin, transplantace důležitých orgánů, náhrada
				srdeční chlopně, operace aorty, AIDS nebo HIV infekce. Právě pro tyto
				případy se hodí připojištění pro případ závažných onemocnění, které v tu
				chvíli zajistí Vaší rodině peněžní prostředky ve výši sjednané pojistné
				částky.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Výskyt některého z onemocnění nebo podstoupení některé
				z operací uvedených v příloze pojistných podmínek.
			</p>
		</>
	),
	"0033": (
		<>
			<h2>Kód pojistného krytí: 0033</h2>
			<p>Název připojištění: Připojištění pro případ závažných onemocnění</p>
			<p>
				Popis připojištění: Připojištění pro případ závažných onemocnění
				poskytuje účinnou ochranu pro případ, kdy pojištěného postihne některé
				ze závažných onemocnění, jako je např. srdeční infarkt, mrtvice,
				rakovina, selhání ledvin, transplantace důležitých orgánů, náhrada
				srdeční chlopně, operace aorty, AIDS nebo HIV infekce. Právě pro tyto
				případy se hodí připojištění pro případ závažných onemocnění, které v tu
				chvíli zajistí Vaší rodině peněžní prostředky ve výši sjednané pojistné
				částky.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Výskyt některého z onemocnění nebo podstoupení některé
				z operací uvedených v příloze pojistných podmínek.
			</p>
		</>
	),
	"0034": (
		<>
			<h2>Kód pojistného krytí: 0034</h2>
			<p>
				POPIS: Připojištění pro případ závažných onemocnění zajišťuje finanční
				pomoc v případě, kdy Vás postihne některé z terminálních nebo závažných
				onemocnění (srdeční infarkt, mrtvice, rakovina, selhání ledvin,
				transplantace důležitých orgánů, náhrada srdeční chlopně, operace aorty,
				AIDS, HIV infekce, oslepnutí, ztráta sluchu, operace věnčitých tepen –
				bypass, nitrolební nádory nezhoubného původu nebo roztroušená skleróza)
				a pravděpodobně to negativně ovlivní nejen Váš život, ale i rodinný
				rozpočet. Právě pro tyto případy se hodí připojištění pro případ
				závažných onemocnění.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Výskyt některého ze závažných onemocnění anebo
				podstoupení některé z operací dle pojistných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná pojistná částka platná k datu pojistné
				události.
			</p>
		</>
	),
	"0036": (
		<>
			<h2>Kód pojistného krytí: 0036</h2>
			<p>
				POPIS: Připojištění denních dávek za dobu nezbytného léčení úrazu
				poskytuje účinnou pojistnou ochranu, která je určena na krytí drobných i
				větších úrazů, zejména hlavy, krku, hrudníku, břicha, horních a dolních
				končetin, ale i dalších částí těla.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz vyjmenovaný v příloze pojistných podmínek, který
				je léčen pod dohledem lékaře a jehož nezbytné léčení trvalo déle než 7
				po sobě následujících dní.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka (denní odškodné) za každý den
				nezbytného léčení (maximálně však po dobu stanovenou pro jednotlivé
				úrazy v příloze pojistných podmínek). Pokud si nezbytné léčení úrazu do
				24 hodin od okamžiku úrazu vyžádá pobyt v nemocnici delší než 24 hodin,
				zvyšuje se po dobu hospitalizace denní dávka na dvojnásobek.
			</p>
		</>
	),
	"0038": (
		<>
			<h2>Kód pojistného krytí: 0038</h2>
			<p>
				POPIS: Připojištění denních dávek za dobu nezbytného léčení úrazu dítěte
				poskytuje účinnou pojistnou ochranu, která je určena na krytí drobných i
				větších úrazů zejména hlavy, krku, hrudníku, břicha, horních a dolních
				končetin, ale i dalších částí těla.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz vyjmenovaný v příloze pojistných podmínek, který
				je léčen pod dohledem lékaře a jehož nezbytné léčení trvalo déle než 7
				po sobě následujících dní.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka (denní odškodné) za každý den
				nezbytného léčení (maximálně však po dobu stanovenou pro jednotlivé
				úrazy v příloze pojistných podmínek). Pokud si nezbytné léčení úrazu do
				24 hodin od okamžiku úrazu vyžádá pobyt v nemocnici delší než 24 hodin,
				zvyšuje se po dobu hospitalizace denní dávka na dvojnásobek.
			</p>
		</>
	),
	"0044": (
		<>
			<h2>0044 - Připojištění konečné diagnózy</h2>
		</>
	),
	"0053": (
		<>
			<h2>Kód pojistného krytí: 0053</h2>
			<p>
				POPIS: Připojištění pro případ smrti nebo závažných onemocnění poskytuje
				pojistnou ochranu pro případ, že Vás postihne některé ze závažných
				onemocnění, jako je srdečný infarkt, mrtvice, rakovina, selhání ledvin,
				transplantace důležitých orgánů, náhrada srdeční chlopně, operace aorty,
				AIDS, HIV infekce, oslepnutí, ztráta sluchu, operace věnčitých tepen –
				bypass, onemocnění plic způsobující dechovou nedostatečnost, nitrolební
				nádory nezhoubného původu nebo roztroušená skleróza. Právě pro tyto
				případy se hodí připojištění pro případ závažných onemocnění, které v tu
				chvíli zajistí Vaší rodině peněžní prostředky ve výši sjednané pojistné
				částky.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Výskyt některého ze závažných onemocnění anebo
				podstoupení některé z operací dle pojistných podmínek + smrt
				pojištěného.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná pojistná částka platná k datu pojistné
				události.
			</p>
		</>
	),
	"0054": (
		<>
			<h2>0054 - Připojištění pro případ závažných onemocnění</h2>
		</>
	),
	"0066": (
		<>
			<h2>Kód pojistného krytí: 0066</h2>
			<p>
				POPIS: Připojištění pro případ zproštění od placení pojistného zajišťuje
				pojistníkovi především prostředky na platbu pojistného (za všechna
				pojištění/připojištění na pojistné smlouvě) v případě, že by byl uznán
				invalidním 3. stupně (dříve plně invalidním). V takovém případě je
				pojistník zproštěn od povinnosti platit pojistné (pojistné za pojistníka
				hradí pojišťovna). Pojistné krytí přitom zůstává tak, jak je.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 3. stupeň invalidity (dříve plná invalidita). Pokles
				pracovní schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu
				musí být nejméně o 70 % + 3. stupeň invalidity musí být uznán v rámci
				posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Zproštění pojistníka od povinnosti platit pojistné za
				hlavní krytí i veškerá připojištění sjednaná v pojistné smlouvě
				(pojistné za pojistníka hradí pojišťovna).
			</p>
		</>
	),
	"0114": (
		<>
			<h2>Kód pojistného krytí: 0114</h2>
			<p>
				POPIS: Připojištění pro případ trvalých následků úrazu s progresivním
				plněním zajišťuje finanční pomoc v případě trvalého poškození po úrazu.
				Každý potřebuje mít pojištěny malé i velké úrazy, protože každý je denně
				vystaven mnoha rizikům (v dopravě, v práci, při sportu nebo hobby) a
				každý může mít vážné finanční problémy, když ho úraz vyřadí z výdělečné
				činnosti (na čas nebo i natrvalo). Od toho je zde právě připojištění
				trvalých následků s progresivním plněním až 400 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající trvalé následky uvedené v
				pojistných podmínkách, pokud jsou trvalé následky příslušným lékařem
				diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) vynásobené tzv. koeficientem progrese v závislosti na rozsahu
				trvalých následků.
			</p>
		</>
	),
	"0118": (
		<>
			<h2>
				0118 - Připojištění trvalých následků úrazu dítěte s progresivním
				plněním
			</h2>
		</>
	),
	"0214": (
		<>
			<h2>Kód pojistného krytí: 0214</h2>
			<p>
				Název připojištění: Připojištění pro případ trvalých následků úrazu s
				progresivním plněním
			</p>
			<p>
				Popis připojištění: Připojištění pro případ trvalých následků úrazu s
				progresivním plněním zajišťuje finanční pomoc v případě trvalého
				poškození po úrazu. Každý z nás je denně vystaven mnoha rizikům (v
				dopravě, v práci, při sportu nebo hobby), které mohou vést k vážným
				finančním problémům, zvláště pokud nás utrpěné úrazy vyřadí z výdělečné
				činnosti (na čas nebo i natrvalo). Právě proto potřebujeme mít pojištěny
				jak malé, tak i velké úrazy. Od toho je zde připojištění pro případ
				trvalých následků s progresivním plněním až 400 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající do 3 let od svého vzniku trvalé
				následky uvedené v příloze pojistných podmínek.
			</p>
		</>
	),
	"0314": (
		<>
			<h2>Kód pojistného krytí: 0314</h2>
			<p>
				POPIS: Připojištění pro případ trvalých následků úrazu s progresivním
				plněním zajišťuje finanční pomoc v případě trvalého poškození po úrazu.
				Každý potřebuje mít pojištěny malé i velké úrazy, protože každý je denně
				vystaven mnoha rizikům (v dopravě, v práci, při sportu nebo hobby) a
				každý může mít vážné finanční problémy, když ho úraz vyřadí z výdělečné
				činnosti (na čas nebo i natrvalo). Od toho je zde právě připojištění
				trvalých následků s pojistným plněním od 1 % pojistné částky, neomezeným
				počtem diagnóz (400+) s progresivním plněním až 400 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající trvalé následky uvedené v
				pojistných podmínkách, pokud jsou trvalé následky příslušným lékařem
				diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) vynásobené tzv. koeficientem progrese v závislosti na rozsahu
				trvalých následků.
			</p>
		</>
	),
	"0KZ2": (
		<>
			<h2>
				0KZ2 - Připojištění pro případ trvalých následků úrazu s progresivním
				plněním
			</h2>
		</>
	),
	"1010": (
		<>
			<h2>1010 - Dočasné životní pojištění</h2>
		</>
	),
	"1020": (
		<>
			<h2>Kód pojistného krytí: 1020</h2>
			<p>
				POPIS: Dočasné životní pojištění poskytuje ochranu pro případ smrti
				pojištěného. Vhodné je především k zajištění úvěrů, je ale možné jej
				využít i pro jiné účely, např. ochranu rodiny proti výpadku příjmů při
				úmrtí živitele. Jeho výhodou je nižší pojistné, které umožní za nízkou
				cenu poměrně vysoké pojistné krytí. V případě, že byl pojistník, který
				pojistnou smlouvu uzavřel s datem počátku před 1.8.2003, uznán
				invalidním ve 3. stupni (dříve plně invalidním), dochází ke zproštění od
				povinnosti platit běžné pojistné a pojistné na celé smlouvě hradí
				pojišťovna. Jestliže se pojištěný dožije konce pojištění, smlouva zaniká
				bez náhrady.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<p>
				<b>a)</b> Smrt pojištěného,
			</p>
			<p>
				<b>b)</b> Uznání 3. stupně invalidity (dříve plná invalidita) v případě
				uzavření pojistné smlouvy s datem počátku před 1.8.2003.
			</p>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<p>
				<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši pojistné
				částky; a
			</p>
			<p>
				<b>b)</b> V případě uznání 3. stupně invalidity (dříve plná invalidita)
				pojistníka, který pojistnou smlouvu uzavřel s datem počátku před
				1.8.2003, zproštění pojistníka od povinnosti platit pojistné za hlavní
				krytí i veškerá připojištění sjednaná v pojistné smlouvě (pojistné za
				pojistníka hradí pojišťovna).
			</p>
		</>
	),
	"1040": (
		<>
			<h2>1040 - Termínované životní pojištění</h2>
		</>
	),
	"1060": (
		<>
			<h2>Kód pojistného krytí: 1060</h2>
			<p>POPIS: Hlavní krytí pro 2. pojištěného - Životní pojištění Rodina.</p>
			<h2>1060 - Pojištění pro případ smrti</h2>
		</>
	),
	"1110": (
		<>
			<h2>1110 - Dočasné životní pojištění</h2>
		</>
	),
	"1210": (
		<>
			<h2>1210 - Úvěrové životní pojištění</h2>
		</>
	),
	"1220": (
		<>
			<h2>Kód pojistného krytí: 1220, 1240</h2>
			<p>
				POPIS: Úvěrové životní pojištění poskytuje ochranu pro případ smrti
				pojištěného. Vhodné je především pro ty, kdo splácí hypotéku nebo jiný
				úvěr a chtějí mít jistotu, že v případě smrti nebudou muset tento
				závazek převzít jejich blízcí. Jeho výhodou je nižší pojistné, které
				umožní za nízkou cenu poměrně vysoké pojistné krytí. V případě, že byl
				pojistník, který pojistnou smlouvu uzavřel s datem počátku před
				1.8.2003, uznán invalidním ve 3. stupni (dříve plně invalidním), dochází
				ke zproštění od povinnosti platit běžné pojistné a pojistné na celé
				smlouvě hradí pojišťovna. Jestliže se pojištěný dožije konce pojištění,
				smlouva zaniká bez náhrady.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<div className="li">
				<p>
					<b>a)</b> Smrt pojištěného,{" "}
				</p>
				<p>
					<b>b)</b> Uznání 3. stupně invalidity (dříve plná invalidita) v
					případě uzavření pojistné smlouvy s datem počátku před 1.8.2003.
				</p>
			</div>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<div className="li">
				<p>
					<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši pojistné
					částky; a{" "}
				</p>
				<p>
					<b>b)</b> V případě uznání 3. stupně invalidity (dříve plná
					invalidita) pojistníka, který pojistnou smlouvu uzavřel s datem
					počátku před 1.8.2003, zproštění pojistníka od povinnosti platit
					pojistné za hlavní krytí i veškerá připojištění sjednaná v pojistné
					smlouvě (pojistné za pojistníka hradí pojišťovna).
				</p>
			</div>
		</>
	),
	"1240": (
		<>
			<h2>Kód pojistného krytí: 1220, 1240</h2>
			<p>
				POPIS: Úvěrové životní pojištění poskytuje ochranu pro případ smrti
				pojištěného. Vhodné je především pro ty, kdo splácí hypotéku nebo jiný
				úvěr a chtějí mít jistotu, že v případě smrti nebudou muset tento
				závazek převzít jejich blízcí. Jeho výhodou je nižší pojistné, které
				umožní za nízkou cenu poměrně vysoké pojistné krytí. V případě, že byl
				pojistník, který pojistnou smlouvu uzavřel s datem počátku před
				1.8.2003, uznán invalidním ve 3. stupni (dříve plně invalidním), dochází
				ke zproštění od povinnosti platit běžné pojistné a pojistné na celé
				smlouvě hradí pojišťovna. Jestliže se pojištěný dožije konce pojištění,
				smlouva zaniká bez náhrady.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<div className="li">
				<p>
					<b>a)</b> Smrt pojištěného,
				</p>
				<p>
					<b>b)</b> Uznání 3. stupně invalidity (dříve plná invalidita) v
					případě uzavření pojistné smlouvy s datem počátku před 1.8.2003.
				</p>
			</div>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<div className="li">
				<p>
					<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši pojistné
					částky; a{" "}
				</p>
				<p>
					<b>b)</b> V případě uznání 3. stupně invalidity (dříve plná
					invalidita) pojistníka, který pojistnou smlouvu uzavřel s datem
					počátku před 1.8.2003, zproštění pojistníka od povinnosti platit
					pojistné za hlavní krytí i veškerá připojištění sjednaná v pojistné
					smlouvě (pojistné za pojistníka hradí pojišťovna).
				</p>
			</div>
		</>
	),
	"2110": (
		<>
			<h2>2110 - Kapitálové životní pojištění</h2>
		</>
	),
	"211P": "-",
	"2120": (
		<>
			<h2>Kód pojistného krytí: 2120</h2>
			<p>
				POPIS: Kapitálové životní pojištění v sobě kombinuje pojistnou ochranu
				pro případ smrti a vytváření úspor. Plnění při dožití můžete využít pro
				zabezpečení financí v důchodovém věku. Jeho výhodou je velká
				flexibilita, díky které můžete pojištění v jeho průběhu přizpůsobovat
				Vaší aktuální životní situaci, potřebám a možnostem. V případě, že byl
				pojistník uznán invalidním ve 3. stupni (dříve plně invalidním), dochází
				ke zproštění od povinnosti platit běžné pojistné a pojistné na celé
				smlouvě hradí pojišťovna). Toto pojištění je vhodné také pro ty, co
				chtějí ušetřit na daních.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<div className="li">
				<p>
					<b>a)</b> Smrt pojištěného z jakékoliv příčiny.
				</p>
				<p>
					<b>b)</b> Dožití se sjednaného konce pojištění pojištěným.
				</p>
				<p>
					<b>c)</b> Uznání 3. stupně invalidity (dříve plná invalidita).
				</p>
			</div>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši celkově
					zaplaceného běžného pojistného na hlavní krytí zvýšeného o případný
					podíl na zisku.
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění pojištěným
					pojistné plnění ve výši pojistné částky pro případ dožití se
					sjednaného konce pojištění zvýšené o případný podíl na zisku.
					<br />
					<b>c)</b> V případě uznání 3. stupně invalidity (dříve plná
					invalidita) pojistníka zproštění pojistníka od povinnosti platit
					pojistné za hlavní krytí i veškerá připojištění sjednaná v pojistné
					smlouvě (pojistné za pojistníka hradí pojišťovna).
				</div>
			</p>
		</>
	),
	"2140": (
		<>
			<h2>Kód pojistného krytí: 2140</h2>
			<p>
				POPIS: Kapitálové životní pojištění v sobě kombinuje pojistnou ochranu
				pro případ smrti a vytváření úspor. Plnění při dožití můžete využít pro
				zabezpečení financí v důchodovém věku. Jeho výhodou je velká
				flexibilita, díky které můžete pojištění v jeho průběhu přizpůsobovat
				Vaší aktuální životní situaci, potřebám a možnostem. Vhodné je také pro
				ty, co chtějí ušetřit na daních.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt pojištěného,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění pojištěným.
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši pojistné
					částky zvýšené o případný podíl na zisku; a<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění pojištěným
					pojistné plnění ve výši pojistné částky zvýšené o případný podíl na
					zisku.
				</div>
			</p>
		</>
	),
	"2160": (
		<>
			<h2>2160 - Pojištění k hypotečnímu úvěru</h2>
		</>
	),
	"2210": (
		<>
			<h2>2210 - Kapitálové životní pojištění</h2>
		</>
	),
	"221P": "-",
	"2220": (
		<>
			<h2>2220 - Kapitálové životní pojištění</h2>
		</>
	),
	"3110": (
		<>
			<h2>3110 - Pojištění odloženého důchodu</h2>
		</>
	),
	"3160": (
		<>
			<h2>Kód pojistného krytí: 3160</h2>
			<p>
				POPIS: Zvláštní institut pojištění Rodina (tech. komponenta 3160)
				navyšující dle pojistných podmínek hodnotu plnění pro případ smrti 1.
				pojištěného nebo i pro případ dožití se konce pojištění 1. pojištěným
				(pak je zároveň součástí tvorby kapitálové hodnoty), pokud je
				jednorázový vklad mimořádného pojistného v době trvání pojištění
				pojistníkem uhrazen.
			</p>
		</>
	),
	"3210": (
		<>
			<h2>3210 - Kapitálově důchodové pojištění</h2>
		</>
	),
	"321P": "-",
	"3220": (
		<>
			<h2>Kód pojistného krytí: 3220</h2>
			<p>
				POPIS: Kapitálově důchodové pojištění poskytuje ochranu pro případ smrti
				a kombinuje ji s vytvářením úspor. Plnění při dožití můžete využít pro
				zabezpečení financí v důchodovém věku. Jeho výhodou je velká
				flexibilita, díky které můžete pojištění v jeho průběhu přizpůsobovat
				Vaší aktuální životní situaci, potřebám a možnostem. V případě, že byl
				pojistník uznán invalidním ve 3. stupni (dříve plně invalidním), dochází
				ke zproštění od povinnosti platit běžné pojistné a pojistné na celé
				smlouvě hradí pojišťovna. Toto pojištění je vhodné také pro ty, co
				chtějí ušetřit na daních.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt pojištěného z jakékoliv příčiny.
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění pojištěným.
					<br />
					<b>c)</b> Uznání 3. stupně invalidity (dříve plná invalidita).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši celkově
					zaplaceného běžného pojistného na hlavní krytí zvýšeného o případný
					podíl na zisku.
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění pojištěným
					pojistné plnění ve výši pojistné částky pro případ dožití se
					sjednaného konce pojištění zvýšené o případný podíl na zisku.
					<br />
					<b>c)</b> V případě uznání 3. stupně invalidity (dříve plná
					invalidita) pojistníka zproštění pojistníka od povinnosti platit
					pojistné za hlavní krytí i veškerá připojištění sjednaná v pojistné
					smlouvě (pojistné za pojistníka hradí pojišťovna).
				</div>
			</p>
			<p>
				<strong>
					Zde na portálu zobrazovaná pojistná částka v pojistném krytí
					pojištěného je pojistnou částkou pro případ dožití se sjednaného konce
					pojištění pojištěným.
				</strong>
			</p>
		</>
	),
	"3240": (
		<>
			<h2>Kód pojistného krytí: 3240</h2>
			<p>
				POPIS: Kapitálově důchodové pojištění poskytuje ochranu pro případ smrti
				a kombinuje ji s vytvářením úspor. Plnění při dožití můžete využít pro
				zabezpečení financí v důchodovém věku. Jeho výhodou je velká
				flexibilita, díky které můžete pojištění v jeho průběhu přizpůsobovat
				Vaší aktuální životní situaci, potřebám a možnostem. Vhodné je také pro
				ty, co chtějí ušetřit na daních.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt pojištěného,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění pojištěným.
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši celkově
					zaplaceného běžného pojistného na hlavní krytí zvýšeného o případný
					podíl na zisku; a<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění pojištěným
					pojistné plnění ve výši pojistné částky pro případ dožití se
					sjednaného konce pojištění zvýšené o případný podíl na zisku.
				</div>
			</p>
			<p>
				<strong>
					Zde na portálu zobrazovaná pojistná částka v pojistném krytí
					pojištěného je pojistnou částkou pro případ dožití se sjednaného konce
					pojištění pojištěným.
				</strong>
			</p>
		</>
	),
	"3260": (
		<>
			<h2>Kód pojistného krytí: 3260</h2>
			<p>
				POPIS: Životní pojištění Rodina Vám umožňuje pojistit na jedné smlouvě
				sebe i další členy své rodiny. Jeho výhodou je velká flexibilita, díky
				které můžete pojištění v průběhu přizpůsobovat Vaší aktuální životní
				situaci, svým potřebám a možnostem. Poskytuje ochranu proti riziku smrti
				a současně Vám umožňuje vytvářet finanční rezervu. Vhodné je také pro
				ty, co chtějí ušetřit na daních.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód 1060).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného pojistné plnění ve výši
					celkově zaplaceného běžného pojistného na hlavní krytí 1. pojištěného
					+ hodnota podílového účtu (popř. hodnota čistého vkladu,
					investovalo-li se dle pojistných podmínek mimořádné pojistné do fondů
					s garantovanou výplatou) + i případně hodnota jednorázového vkladu,
					byl-li dle pojistných podmínek vložen;
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši pojistné částky pro případ dožití se
					sjednaného konce pojištění zvýšené o případný podíl na zisku (tzv.
					věrnostní bonus) + hodnota podílového účtu + i případně hodnota
					jednorázového vkladu, byl-li dle pojistných podmínek vložen (součástí
					tvorby kapitálové hodnoty); a <br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
			<p>
				<strong>
					Zde na portálu zobrazovaná pojistná částka v pojistném krytí 1.
					pojištěného je pojistnou částkou pro případ dožití se sjednaného konce
					pojištění 1. pojištěným.
				</strong>
			</p>
		</>
	),
	"326P": "-",
	"3310": (
		<>
			<h2>3310 - Pojištění jistého důchodu</h2>
		</>
	),
	"3311": (
		<>
			<h2>3311 - Pojištění jistého důchodu</h2>
		</>
	),
	"331P": "-",
	"3410": (
		<>
			<h2>3410 - Pojištění doživotního důchodu</h2>
		</>
	),
	"3411": (
		<>
			<h2>3411 - Pojištění doživotního důchodu</h2>
		</>
	),
	"341P": "-",
	"3430": (
		<>
			<h2>3430 - Pojištění smíšeného důchodu</h2>
		</>
	),
	"3431": (
		<>
			<h2>3431 - Pojištění smíšeného důchodu</h2>
		</>
	),
	"343P": "-",
	"3450": (
		<>
			<h2>3450 - Pojištění růstového důchodu</h2>
		</>
	),
	"3451": (
		<>
			<h2>3451 - Pojištění růstového důchodu</h2>
		</>
	),
	"4010": (
		<>
			<h2>4010 - Trvalé životní pojištění</h2>
		</>
	),
	"	401P": "-",
	"4020": (
		<>
			<h2>4020 - Trvalé životní pojištění</h2>
		</>
	),
	"5040": (
		<>
			<h2>5040 - Stipendijní pojištění</h2>
		</>
	),
	"504P": "-",
	"5050": (
		<>
			<h2>5050 - Stipendijní pojištění</h2>
		</>
	),
	"505P": "-",
	"6020": (
		<>
			<h2>6020 - Svatební pojištění</h2>
		</>
	),
	"602P": "-",
	"7010": (
		<>
			<h2>7010 - Vkladové životní pojištění</h2>
		</>
	),
	"7110": (
		<>
			<h2>7110 - Vkladové životní pojištění</h2>
		</>
	),
	"711P": "-",
	"7120": (
		<>
			<h2>7120 - Vkladové životní pojištění</h2>
		</>
	),
	A020: (
		<>
			<h2>A020 - Rizikové životní pojištění</h2>
		</>
	),
	A150: (
		<>
			<h2>A150 - Investiční životní pojištění</h2>
		</>
	),
	CSO5: (
		<>
			<h2>Kód pojistného krytí: CSO5</h2>
			<p>
				POPIS: Připojištěním pro případ smrti s klesající pojistnou částkou se
				zvyšuje pojistné plnění pro případ smrti z jakékoliv příčiny (při
				pojistné události smrt se pak vyplácí pojistné plnění jak z hlavního
				krytí, tak i z tohoto připojištění). Pojistná částka je u tohoto
				připojištění lineárně klesající a je tedy ke každému výročí snížena o
				1/n sjednané pojistné částky, kde &quot;n&quot; představuje sjednanou
				pojistnou dobu v letech.
			</p>
			<p>POJISTNÁ UDÁLOST: Smrt z jakékoliv příčiny.</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši pojistné částky platné ke dni
				vzniku pojistné události.
			</p>
		</>
	),
	CSO6: (
		<>
			<h2>Kód pojistného krytí: CSO6</h2>
			<p>
				POPIS: Připojištěním pro případ smrti se zvyšuje pojistné plnění pro
				případ smrti z jakékoliv příčiny (při pojistné události smrt se pak
				vyplácí pojistné plnění jak z hlavního krytí, tak i z tohoto
				připojištění).
			</p>
			<p>POJISTNÁ UDÁLOST: Smrt z jakékoliv příčiny.</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši pojistné částky platné ke dni
				vzniku pojistné události.
			</p>
		</>
	),
	CZV3: (
		<>
			<h2>Kód pojistného krytí: CZV3</h2>
			<p>
				POPIS: Připojištění pro případ závažných onemocnění dospělých zajišťuje
				finanční pomoc v případě, kdy pojištěného postihne některé z
				terminálních nebo závažných onemocnění (srdeční infarkt, mrtvice,
				rakovina, selhání ledvin, transplantace životně důležitých orgánů,
				náhrada srdeční chlopně, operace aorty, AIDS, HIV infekce, oslepnutí,
				ztráta sluchu, operace věnčitých tepen – bypass, onemocnění plic
				způsobující dechovou nedostatečnost, nitrolební nádory nezhoubného
				původu, roztroušená skleróza, encefalitida nebo žloutenka a mnoho
				dalších).
			</p>
			<p>
				POJISTNÁ UDÁLOST: Stanovení diagnózy závažného onemocnění anebo
				podstoupení některé z operací dle pojistných podmínek (s bonusem 50 %
				pojistné částky v případě terminální fáze rakoviny).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši sjednané pojistné částky nebo
				její části, a to v závislosti na typu závažného onemocnění (procentuální
				hodnota pojistného plnění ve vztahu ke sjednané pojistné částce je
				uvedena v příloze pojistných podmínek).
			</p>
		</>
	),
	CZR3: (
		<>
			<h2>Kód pojistného krytí: CZR3</h2>
			<p>
				POPIS: Připojištění pro případ rakoviny dospělých poskytuje účinnou
				pojistnou ochranu v případě, že Vás v průběhu života postihne toto
				závažné onemocnění.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Stanovení diagnózy rakoviny, terminální fáze rakoviny
				(s bonusem 50 % pojistné částky) a/nebo diagnózy tzv. rakoviny in situ.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši sjednané pojistné částky nebo
				její části, a to v závislosti na typu diagnózy (procentuální hodnota
				pojistného plnění ve vztahu ke sjednané pojistné částce je uvedena v
				příloze pojistných podmínek).
			</p>
		</>
	),
	CID4: (
		<>
			<h2>Kód pojistného krytí: CID4</h2>
			<p>
				POPIS: Připojištění pro případ invalidního důchodu poskytuje komplexní
				pojistnou ochranu pro případ invalidity (1., 2. i 3. stupně) a pojištěný
				se tak v těchto případech nemusí se obávat o snížení svého životního
				standardu. Pojistné plnění z tohoto připojištění je jednorázovou formou.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 1., 2. nebo 3. stupeň invalidity. Pokles pracovní
				schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu musí být
				nejméně o 35 % (max. však o 49 %) u invalidity 1. stupně, nejméně o 50 %
				(max. však o 69 %) u invalidity 2. stupně anebo nejméně o 70 % u
				invalidity 3. stupně + příslušný stupeň invalidity musí být uznán v
				rámci posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: 1. stupeň invalidity = 20 % sjednané pojistné částky 2.
				stupeň invalidity = 100 % sjednané pojistné částky 3. stupeň invalidity
				= 100 % sjednané pojistné částky Progrese ve výši 150 % = v případě 3.
				stupně invalidity a jedné z diagnóz – kvadruplegie nebo terminální
				onemocnění.
			</p>
		</>
	),
	CPN4: (
		<>
			<h2>Kód pojistného krytí: CPN4</h2>
			<p>
				POPIS: Připojištění pro případ pracovní neschopnosti zajišťuje finanční
				pomoc v případě, kdy pojištěný nemůže podle lékařského rozhodnutí žádným
				způsobem vykonávat a nevykonává své zaměstnání nebo svou samostatnou
				výdělečnou činnost. Součástí je i tzv. bonus za bezeškodní průběh, kdy
				za každý rok (s výjimkou prvního), ve kterém nebyl vůči pojišťovně
				uplatňován nárok na pojistné plnění z tohoto připojištění, poskytne
				pojišťovna ve prospěch pojistné smlouvy bonus za bezeškodní průběh ve
				výši 10 % pojistného zaplaceného za toto připojištění v uplynulém roce.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost pojištěného
				(podmínkou je trvání pracovní neschopnosti minimálně 29 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka od 29. dne lékařem přiznané
				pracovní neschopnosti (max. však ve výši odpovídající skutečné ztrátě na
				výdělku pojištěného; tento limit neplatí, pokud sjednaná denní dávka
				nepřesahuje maximální sjednanou denní dávku stanovenou pojišťovnou, u
				které se příjem pojištěného nezkoumá). Maximální délka denní dávky je 52
				týdnů.
			</p>
		</>
	),
	CHO4: (
		<>
			<h2>Kód pojistného krytí: CHO4</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici poskytuje
				pojistnou ochranu pro případ hospitalizace. Díky těmto finančním
				prostředkům si můžete zajistit nadstandardní nemocniční péči, sjednat
				pomoc v domácnosti v době své nepřítomnosti nebo pomoci své rodině s
				cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>POJISTNÁ UDÁLOST: Hospitalizace (musí trvat minimálně 24 hodin).</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	CHU4: (
		<>
			<h2>Kód pojistného krytí: CHU4</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici následkem úrazu
				poskytuje pojistnou ochranu pro případ hospitalizace. Díky těmto
				finančním prostředkům si můžete zajistit nadstandardní nemocniční péči,
				sjednat pomoc v domácnosti v době své nepřítomnosti nebo pomoci své
				rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace v důsledku úrazu (musí trvat minimálně
				24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	SZV3: "-",
	SZR3: "-",
	SID4: "-",
	SPN3: "-",
	SHO1: "-",
	SHU5: "-",
	CDL1: (
		<>
			<h2>Kód pojistného krytí: CDL1</h2>
			<p>
				POPIS: Připojištění denního odškodného za léčení úrazu s progresí
				poskytuje účinnou pojistnou ochranu, která je určena na krytí nákladů v
				souvislosti s léčením vážnějších úrazů , jako jsou vykloubení,
				zlomeniny, popáleniny a poranění nervů a smyslových nebo vnitřních
				orgánů. Celkem se jedná o 393 diagnózy zranění s připodobňováním,
				není-li dané zranění přímo uvedeno v pojistných podmínkách. Pokud si
				léčení do 24 hodin od okamžiku úrazu vyžádá pobyt v nemocnici delší než
				24 hodin, zvyšuje se po dobu hospitalizace pojistné plnění na
				dvojnásobek.{" "}
			</p>
			<p>
				POJISTNÁ UDÁLOST: Nezbytné léčení tělesného poškození způsobeného úrazem
				za předpokladu, že je vyjmenováno v příloze pojistných podmínek nebo jej
				lze na základě posouzení lékaře pojišťovny k tam uvedenému tělesnému
				poškození připodobnit.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka za počet dní uvedený u konkrétní
				diagnózy v pojistných podmínkách krát koeficient progrese. Ten se
				zvyšuje v závislosti na závažnosti úrazu. Například u úrazů se
				standardizovanou dobou léčení minimálně 170 dní zvýší plnění na
				3násobek. Pokud si nezbytné léčení do 24 hodin od okamžiku úrazu vyžádá
				pobyt v nemocnici delší než 24 hodin, zvyšuje se po dobu hospitalizace
				denní dávka na dvojnásobek. Pokud v průběhu léčby úrazu dojde k jedné z
				komplikací uvedené v pojistných podmínkách a skutečná doba nezbytného
				léčení překročí počet dní léčení diagnózy, za kterou bylo poskytnuto
				pojistné plnění, bude za každý takový den navíc vyplacena sjednaná denní
				dávka, a to až do celkové doby léčení 365 dní.
			</p>
		</>
	),
	CDU1: (
		<>
			<h2>Kód pojistného krytí: CDU1</h2>
			<p>
				POPIS: Připojištění bolestného za drobné úrazy poskytuje pojistnou
				ochranu pro případ méně vážných úrazů. Jedná se o 57 poranění jako jsou
				pohmoždění, podvrtnutí a chirurgicky ošetřené rány. Připojištění slouží
				jako kompenzace utrpěné bolesti.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Nezbytné léčení tělesného poškození způsobené úrazem,
				které je vyjmenováno v příloze pojistných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:Pojistná částka uvedená pro dané tělesné poškození v
				pojistných podmínkách a variantu sjednanou v pojistné smlouvě.
			</p>
		</>
	),
	CDL2: (
		<>
			<h2>Kód pojistného krytí: CDL2</h2>
			<p>
				POPIS: Připojištění denního odškodného za léčení úrazu dítěte s progresí
				poskytuje účinnou pojistnou ochranu, která je určena na krytí nákladů v
				souvislosti s vážnějšími úrazy dítěte, jako jsou vykloubení, zlomeniny,
				popáleniny a poranění nervů, smyslových nebo vnitřních orgánů. Celkem se
				jedná o 393 diagnózy zranění s připodobňováním, není-li dané zranění
				přímo uvedeno v pojistných podmínkách.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Nezbytné léčení tělesného poškození způsobeného úrazem
				za předpokladu, že je vyjmenováno v příloze pojistných podmínek nebo jej
				lze na základě posouzení lékaře pojišťovny k tam uvedenému tělesnému
				poškození připodobnit.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka za počet dní uvedený u konkrétní
				diagnózy v pojistných podmínkách krát koeficient progrese. Ten se
				zvyšuje v závislosti na závažnosti úrazu. Například u úrazů se
				standardizovanou dobou léčení minimálně 170 dní zvýší plnění na
				3násobek. Pokud si nezbytné léčení do 24 hodin od okamžiku úrazu vyžádá
				pobyt v nemocnici delší než 24 hodin, zvyšuje se po dobu hospitalizace
				denní dávka na 1,5násobek. Pokud v průběhu léčby úrazu dítěte dojde k
				jedné z komplikací uvedené v pojistných podmínkách a skutečná doba
				nezbytného léčení překročí počet dní léčení diagnózy, za kterou bylo
				poskytnuto pojistné plnění, bude za každý takový den navíc vyplacena
				sjednaná denní dávka, a to až do celkové doby léčení 365 dní.
			</p>
		</>
	),
	CDU2: (
		<>
			<h2>Kód pojistného krytí: CDU2</h2>
			<p>
				POPIS: Připojištění bolestného za drobné úrazy dítěte poskytuje
				pojistnou ochranu pro případ méně vážných úrazů pojištěného dítěte.
				Jedná se o 46 poranění jako jsou podvrtnutí a chirurgicky ošetřené rány.
				Připojištění slouží jako kompenzace utrpěné bolesti.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Nezbytné léčení tělesného poškození způsobené úrazem,
				které je vyjmenováno v příloze pojistných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:Pojistná částka uvedená pro dané tělesné poškození v
				pojistných podmínkách a variantu sjednanou v pojistné smlouvě.
			</p>
		</>
	),
	UZ3C: (
		<>
			<h2>Kód pojistného krytí: UZ3C</h2>
			<p>
				POPIS: Investiční životní pojištění NN Smart nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<div className="li">
				<p>
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
				</p>
				<p>
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
				</p>
				<p>
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS22).
				</p>
			</div>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného bude vyplacena výše pojistné
					částky pro případ smrti 1. pojištěného nebo ve výši hodnoty podílového
					účtu, je-li tato hodnota vyšší – tzv. varianta „vyšší z“. (neplatí pro
					smlouvy vzniklé konverzí, které nabízí více variant plnění) <br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	UM5C: (
		<>
			<h2>Kód pojistného krytí: UM5C</h2>
			<p>
				POPIS: Investiční životní pojištění NN Smart nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS22).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného bude vyplacena výše pojistné
					částky pro případ smrti 1. pojištěného nebo ve výši hodnoty podílového
					účtu, je-li tato hodnota vyšší – tzv. varianta „vyšší z“. (neplatí pro
					smlouvy vzniklé konverzí, které nabízí více variant plnění)
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	UM6C: (
		<>
			<h2>Kód pojistného krytí: UM6C</h2>
			<p>
				POPIS: Investiční životní pojištění ZFP Život+ nabízí komplexní výhody
				ve formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS21).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného bude vyplacena výše pojistné
					částky pro případ smrti 1. pojištěného nebo ve výši hodnoty podílového
					účtu, je-li tato hodnota vyšší – tzv. varianta „vyšší z“. (neplatí pro
					smlouvy vzniklé konverzí, které nabízí více variant plnění)
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	RZ4C: (
		<>
			<h2>Kód pojistného krytí: RZ4C</h2>
			<p>
				POPIS: Životní pojištění NN Život je produkt pro Váš aktivní život,
				kterým pojistíte sebe i své blízké. Jeho výhodou je velká flexibilita,
				díky které můžete pojištění v průběhu přizpůsobovat Vaší aktuální
				životní situaci, svým potřebám a možnostem. Obsahuje navíc bonus
				zvyšující pojistné plnění v případě, že k úrazu, jehož následkem
				pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse, vlaku,
				lodi, letadle, případně dalších dopravních prostředcích.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<p>a) Smrt 1. pojištěného z jakékoliv příčiny.</p>
			<p>b) Smrt 2. pojištěného z jakékoliv příčiny (viz kód R22C).</p>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<p>
				a) V případě smrti 1. pojištěného pojistné plnění ve výši sjednané
				pojistné částky pro 1. pojištěného.
			</p>
			<p>
				b) V případě smrti 2. pojištěného pojistné plnění ve výši sjednané
				pojistné částky pro 2. pojištěného. Pokud k úrazu, jehož následkem 1.
				nebo 2. pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse,
				vlaku, lodi, letadle, případně dalších dopravních prostředcích dle
				pojistných podmínek, vyplatí pojišťovna navíc bonus ve výši uvedené v
				pojistné smlouvě.
			</p>
		</>
	),
	RM2C: (
		<>
			<h2>Kód pojistného krytí: RM2C</h2>
			<p>
				POPIS: Životní pojištění NN Život je produkt pro Váš aktivní život,
				kterým pojistíte sebe i své blízké. Jeho výhodou je velká flexibilita,
				díky které můžete pojištění v průběhu přizpůsobovat Vaší aktuální
				životní situaci, svým potřebám a možnostem. Obsahuje navíc bonus
				zvyšující pojistné plnění v případě, že k úrazu, jehož následkem
				pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse, vlaku,
				lodi, letadle, případně dalších dopravních prostředcích.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<p>a) Smrt 1. pojištěného z jakékoliv příčiny.</p>
			<p>b) Smrt 2. pojištěného z jakékoliv příčiny (viz kód R22C).</p>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<p>
				a) V případě smrti 1. pojištěného pojistné plnění ve výši sjednané
				pojistné částky pro 1. pojištěného.
			</p>
			<p>
				b) V případě smrti 2. pojištěného pojistné plnění ve výši sjednané
				pojistné částky pro 2. pojištěného. Pokud k úrazu, jehož následkem 1.
				nebo 2. pojištěný zemřel, došlo při dopravní nehodě v autě, autobuse,
				vlaku, lodi, letadle, případně dalších dopravních prostředcích dle
				pojistných podmínek, vyplatí pojišťovna navíc bonus ve výši uvedené v
				pojistné smlouvě.
			</p>
		</>
	),
	WPR5: "-",
	WPRC: (
		<>
			<h2>WPRC - Komplexné pripoistenie oslobodenia od platenia poistného</h2>
		</>
	),
	WPRJ: (
		<>
			<h2>WPRJ - Oslobodenie od platenia poistného</h2>
		</>
	),
	WPRK: "-",
	XDR0: (
		<>
			<h2>XDR0 - Doplnkové úrazové pripoistenie</h2>
		</>
	),
	XDR1: (
		<>
			<h2>XDR1 - Doplnkové úrazové pripoistenie</h2>
		</>
	),
	XDR2: (
		<>
			<h2>XDR2 - Následok úrazu doplnkový</h2>
		</>
	),
	XDR3: (
		<>
			<h2>XDR3 - Doplnkové úrazové pripoistenie</h2>
		</>
	),
	Z302: (
		<>
			<h2>
				Z302 - Připojištění pracovní neschopnosti v důsledku úrazu delší než 14
				dní
			</h2>
		</>
	),
	Z304: (
		<>
			<h2>
				Z304 - Připojištění pracovní neschopnosti v důsledku úrazu delší než 28
				dní
			</h2>
		</>
	),
	NL11: (
		<>
			<h2>
				NL11 - Doživotný dôchodok bez výplaty pozostalostného dôchodku plán č.1
			</h2>
		</>
	),
	NL21: (
		<>
			<h2>
				NL21 - Doživotný dôchodok bez výplaty pozostalostného dôchodku plán č.2
			</h2>
		</>
	),
	NL31: (
		<>
			<h2>
				NL31 - Doživotný dôchodok bez výplaty pozostalostného dôchodku plán 1S,
				3Z
			</h2>
		</>
	),
	NL41: (
		<>
			<h2>NL41 - Doživotný dôchodok</h2>
		</>
	),
	NS11: (
		<>
			<h2>
				NS11 - Doživotný dôchodok s výplatou pozostalostného dôchodku plán č.1
			</h2>
		</>
	),
	NS21: (
		<>
			<h2>
				NS21 - Doživotný dôchodok s výplatou pozostalostného dôchodku plán č.2
			</h2>
		</>
	),
	NS31: (
		<>
			<h2>
				NS31 - Doživotný dôchodok s výplatou pozostalostného dôchodku plán 1S,
				3Z
			</h2>
		</>
	),
	NT11: (
		<>
			<h2>
				NT11 - Dôchodok na dobu určitú bez výplaty pozostalostného dôchodku plán
				č.1
			</h2>
		</>
	),
	NT21: (
		<>
			<h2>
				NT21 - Dôchodok na dobu určitú bez výplaty pozostalostného dôchodku plán
				č.2
			</h2>
		</>
	),
	NT31: (
		<>
			<h2>
				NT31 - Dôchodok na dobu určitú bez výplaty pozostalostného dôchodku plán
				1S,3Z
			</h2>
		</>
	),
	P006: (
		<>
			<h2>P006 - Zproštění od placení pojistného</h2>
		</>
	),
	PDR0: (
		<>
			<h2>PDR0 - Pripoistenie trvalých následkov úrazu</h2>
		</>
	),
	PDR1: (
		<>
			<h2>PDR1 - Pripoistenie trvalých následkov úrazu</h2>
		</>
	),
	PDR2: (
		<>
			<h2>PDR2 - Trvalý následok úrazu</h2>
		</>
	),
	PDR3: (
		<>
			<h2>PDR3 - Pripoistenie trvalých následkov úrazu</h2>
		</>
	),
	PDR4: (
		<>
			<h2>PDR4 - Pripoistenie trvalých následkov úrazu</h2>
		</>
	),
	PDR5: (
		<>
			<h2>PDR5 - Pripoistenie trvalých následkov úrazu</h2>
		</>
	),
	PDR6: "-",
	R012: (
		<>
			<h2>Kód pojistného krytí: R012</h2>
			<p>
				POPIS: Připojištěním pro případ smrti následkem úrazu se zvyšuje
				pojistné plnění pro případ smrti způsobené úrazem.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Smrt úrazem, za předpokladu, že k úmrtí došlo do 3 let
				od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistná částka platná k datu pojistné události v
				případě smrti úrazem.
			</p>
		</>
	),
	R030: (
		<>
			<h2>Kód pojistného krytí: R030</h2>
			<p>Název připojištění: Připojištění pro případ úrazu</p>
			<p>
				Popis připojištění: Připojištění pro případ úrazu poskytuje účinnou
				ochranu určenou ke krytí drobných i větších úrazů a zaručující
				jednoduchou a rychlou pomoc.
			</p>
			<p>POJISTNÁ UDÁLOST: Úraz uvedený v příloze pojistných podmínek.</p>
		</>
	),
	R101: (
		<>
			<h2>Kód pojistného krytí: R101</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici následkem úrazu
				poskytuje pojistnou ochranu pro případ hospitalizace následkem úrazu.
				Díky těmto finančním prostředkům si můžete zajistit nadstandardní
				nemocniční péči, sjednat pomoc v domácnosti v době své nepřítomnosti
				nebo pomoci své rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace v důsledku úrazu (musí trvat minimálně 4
				dny, při hospitalizaci při porodu min. 8 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	R21C: (
		<>
			<h2>Kód pojistného krytí: R21C</h2>
			<p>
				POPIS: Hlavní krytí pro 2. pojištěného - Životní pojištění ProAktiv.
			</p>
		</>
	),
	R21S: (
		<>
			<h2>R21S - Dočasné životné poistenie</h2>
		</>
	),
	RPFC: (
		<>
			<h2>RPFC - Pojištění pro případ smrti</h2>
		</>
	),
	RT1C: (
		<>
			<h2>Kód pojistného krytí: RT1C</h2>
			<p>
				POPIS: Dočasné životní pojištění je pojištěním vhodným k zajištění
				úvěru, nebo v případě že vykonáváte rizikové povolání nebo máte
				rizikového koníčka.Jeho výhodou je nižší pojistné, které umožňuje za
				nízkou cenu poměrně vysokou pojistnou ochranu.
			</p>
			<p>POJISTNÁ UDÁLOST: Smrt pojištěného z jakékoliv příčiny.</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši pojistné částky platné ke dni
				vzniku pojistné události.
			</p>
		</>
	),
	RT1S: (
		<>
			<h2>RT1S - Dočasné životné poistenie</h2>
		</>
	),
	RT2C: (
		<>
			<h2>RT2C - Úvěrové životní pojištění</h2>
		</>
	),
	RT3C: (
		<>
			<h2>RT3C - Úvěrové životní pojištění</h2>
		</>
	),
	RZ0C: (
		<>
			<h2>RZ0C - ProAktiv Start</h2>
		</>
	),
	RZ0S: (
		<>
			<h2>RZ0S - ZFP Život NN SMART</h2>
		</>
	),
	RZ14: (
		<>
			<h2>Kód pojistného krytí: RZ14</h2>
			<p>
				POPIS: Připojištění pro případ trvalých následků úrazu s progresivním
				plněním zajišťuje finanční pomoc v případě trvalého poškození po úrazu.
				Každý potřebuje mít pojištěny malé i velké úrazy, protože každý je denně
				vystaven mnoha rizikům (v dopravě, v práci, při sportu nebo hobby) a
				každý může mít vážné finanční problémy, když ho úraz vyřadí z výdělečné
				činnosti (na čas nebo i natrvalo). Od toho je zde právě připojištění
				trvalých následků s progresivním plněním až 400 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající trvalé následky uvedené v
				pojistných podmínkách, pokud jsou trvalé následky příslušným lékařem
				diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) vynásobené tzv. koeficientem progrese v závislosti na rozsahu
				trvalých následků.
			</p>
		</>
	),
	RZ1C: (
		<>
			<h2>Kód pojistného krytí: RZ1C</h2>
			<p>
				POPIS: Životní pojištění ProAktiv je produkt pro Váš aktivní život,
				kterým pojistíte sebe i své blízké. Jeho výhodou je velká flexibilita,
				díky které můžete pojištění v průběhu přizpůsobovat Vaší aktuální
				životní situaci, svým potřebám a možnostem.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<div className="li">
				<p>
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny.
				</p>
				<p>
					<b>b)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód R21C).
				</p>
			</div>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<div className="li">
				<p>
					<b>a)</b> V případě smrti 1. pojištěného pojistné plnění ve výši
					sjednané pojistné částky pro 1. pojištěného.
				</p>
				<p>
					<b>b)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					sjednané pojistné částky pro 2. pojištěného.
				</p>
			</div>
		</>
	),
	RZ1S: (
		<>
			<h2>RZ1S - Životné poistenie ProAktivt</h2>
		</>
	),
	RZ36: (
		<>
			<h2>Kód pojistného krytí: RZ36</h2>
			<p>
				POPIS: Připojištění denních dávek za dobu nezbytného léčení úrazu
				poskytuje účinnou pojistnou ochranu, která je určena na krytí drobných i
				větších úrazů, zejména hlavy, krku, hrudníku, břicha, horních a dolních
				končetin, ale i dalších částí těla.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz vyjmenovaný v příloze pojistných podmínek, který
				je léčen pod dohledem lékaře a jehož nezbytné léčení trvalo déle než 7
				po sobě následujících dní.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka (denní odškodné) za každý den
				nezbytného léčení (maximálně však po dobu stanovenou pro jednotlivé
				úrazy v příloze pojistných podmínek). Pokud si nezbytné léčení úrazu do
				24 hodin od okamžiku úrazu vyžádá pobyt v nemocnici delší než 24 hodin,
				zvyšuje se po dobu hospitalizace denní dávka na dvojnásobek.
			</p>
		</>
	),
	RZ3C: (
		<>
			<h2>Kód pojistného krytí: RZ3C</h2>
			<p>
				POPIS: Životní pojištění NN Smart Senior je vytvořené na míru klientům
				ve věku nad 55 let. Jde o flexibilní pojištění, které Vám umožní
				zhodnocovat volné finanční prostředky v garantovaném fondu a současně
				pojistnou ochranu před případnými riziky. Nabízí na českém trhu unikátní
				možnost připojistit se pro případ nesoběstačnosti a možnost zakoupit si
				připojištění asistenčních služeb.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<p>a) Smrt pojištěného z jakékoliv příčiny.</p>
			<p>b) Dožití se sjednaného konce pojištění pojištěným.</p>
			<p>POJISTNÉ PLNĚNÍ:</p>
			<p>
				a) V případě smrti pojištěného pojistné plnění ve výši součtu sjednané
				pojistné částky a hodnoty podílového účtu.
			</p>
			<p>
				b) V případě dožití se sjednaného konce pojištění pojištěným pojistné
				plnění ve výši hodnoty podílového účtu.
			</p>
		</>
	),
	RZ3S: "-",
	RZD5: "-",
	RZH1: (
		<>
			<h2>Kód pojistného krytí: RZH1</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici následkem úrazu
				poskytuje pojistnou ochranu pro případ hospitalizace následkem úrazu.
				Díky těmto finančním prostředkům si můžete zajistit nadstandardní
				nemocniční péči, sjednat pomoc v domácnosti v době své nepřítomnosti
				nebo pomoci své rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace v důsledku úrazu (musí trvat minimálně
				24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	RZP6: "-",
	S4R0: (
		<>
			<h2>S4R0 - Maturita</h2>
		</>
	),
	S4R3: (
		<>
			<h2>S4R3 - Maturita</h2>
		</>
	),
	S4RP: "-",
	S5R0: (
		<>
			<h2>S5R0 - Promócia</h2>
		</>
	),
	S5R3: (
		<>
			<h2>S5R3 - Promócia</h2>
		</>
	),
	S5RP: "-",
	S5RS: "-",
	SAS0: (
		<>
			<h2>SAS0 - Asistenčné služby</h2>
		</>
	),
	SAS3: (
		<>
			<h2>SAS3 - Asistenčné služby</h2>
		</>
	),
	SDU3: (
		<>
			<h2>SDU3 - Pripoistenie následkov úrazu</h2>
		</>
	),
	SHO3: (
		<>
			<h2>SHO3 - Pripoistenie hospitalizácie</h2>
		</>
	),
	SHU1: "-",
	SHU3: (
		<>
			<h2>SHU3 - Hospitalizácia v dôsledku úrazu</h2>
		</>
	),
	SID1: "-",
	SID2: "-",
	SID3: "-",
	SLC3: (
		<>
			<h2>SLC3 - Pripoistenie pre prípad nesebestačnosti</h2>
		</>
	),
	SNL1: "-",
	SNL2: "-",
	SNLF: (
		<>
			<h2>
				SNLF - Pripoistenie denných dávok za dobu nevyhnutného liečenia úrazu
				dieťaťa s progresiou
			</h2>
		</>
	),
	SOP1: "-",
	SOP2: "-",
	SP1C: (
		<>
			<h2>SP1C - Stabil Profit</h2>
		</>
	),
	SP1S: (
		<>
			<h2>SP1S - Stabil profit</h2>
		</>
	),
	SP2C: (
		<>
			<h2>SP2C - Stabil Profit</h2>
		</>
	),
	SP2S: (
		<>
			<h2>SP2S - Stabil profit</h2>
		</>
	),
	SPN1: "-",
	SPN2: (
		<>
			<h2>
				SPN2 - Pripoistenie denných dávok pre prípad pracovnej neschopnosti
			</h2>
		</>
	),
	SRDF: "-",
	SRI1: (
		<>
			<h2>SRI1 - Oslobodenie od platenia poisteného s výplatou renty</h2>
		</>
	),
	SS21: (
		<>
			<h2>SS21 - Poistenie pre prípad smrti</h2>
		</>
	),
	SSO1: (
		<>
			<h2>SSO1 - Dočasné životné pripoistenie</h2>
		</>
	),
	SSO2: (
		<>
			<h2>SSO2 - Dočasné životné pripoistenie</h2>
		</>
	),
	SSO3: "-",
	STN2: "-",
	STN3: (
		<>
			<h2>
				STN3 - Doplnkové pripoistenie pre prípad trvalých následkov úrazu alebo
				choroby
			</h2>
		</>
	),
	SUD1: "-",
	SUD2: "-",
	SZR1: "-",
	SZV1: "-",
	SZV2: "-",
	T024: (
		<>
			<h2>Kód pojistného krytí: T024</h2>
			<p>
				POPIS: Připojištění pro případ plného invalidního důchodu následkem
				úrazu poskytuje pojistnou ochranu pro případ plné invalidity (dnes
				invalidita 3. stupně) způsobené úrazem a pojištěný se tak v těchto
				případech nemusí se obávat o snížení svého životního standardu.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Uznání 3. stupně invalidity (dříve plná invalidita)
				následkem úrazu pojišťovnou, jestliže z důvodu dlouhodobě nepříznivého
				zdravotního stavu došlo k poklesu schopnosti soustavné výdělečné
				činnosti nejméně o 66 % a pojištěný žádnou soustavnou výdělečnou činnost
				neprovozuje, nebo pro zdravotní postižení je schopen soustavné výdělečné
				činnosti jen za zcela mimořádných podmínek.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve formě důchodu, který se vyplácí v
				pravidelných měsíčních dávkách ve výši 1/12 pojistné částky platné ke
				dni vzniku pojistné události. Důchod bude vyplácen ode dne pojistné
				události, nejdříve však po uplynutí 6 měsíců od úrazu, v jehož důsledku
				pojistná událost nastala. V době výplaty důchodu pojišťovna k výročnímu
				dni počátku připojištění zvýší roční hodnotu důchodu o 5 % z pojistné
				částky platné ke dni pojistné události. Dnem konce připojištění končí
				výplata důchodu a připojištění zaniká.
			</p>
		</>
	),
	T053: (
		<>
			<h2>Kód pojistného krytí: T053</h2>
			<p>
				POPIS: Připojištění pro případ smrti nebo diagnózy závažného onemocnění
				poskytuje účinnou pojistnou ochranu pro případ, že Vás postihne některé
				ze závažných onemocnění, jako je srdečný infarkt, mrtvice, rakovina,
				selhání ledvin, transplantace důležitých orgánů, náhrada srdeční
				chlopně, operace aorty, AIDS, HIV infekce, oslepnutí, ztráta sluchu,
				operace věnčitých tepen – bypass, nitrolební nádory nezhoubného původu,
				angioplastika nebo roztroušená skleróza. Pravděpodobně to negativně
				ovlivní nejen Váš život, ale i rodinný rozpočet. Právě pro tyto případy
				se hodí připojištění pro případ závažných onemocnění nebo smrti, které v
				tu chvíli zajistí Vaší rodině peněžní prostředky ve výši sjednané
				pojistné částky.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Výskyt některého ze závažných onemocnění anebo
				podstoupení některé z operací dle pojistných podmínek + smrt
				pojištěného.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná pojistná částka platná k datu pojistné
				události.
			</p>
		</>
	),
	T150: (
		<>
			<h2>
				T150 - Životní pojištění Investor Plus (do 31.10.2002 Důchodové
				pojištění Investor)
			</h2>
			<p>
				Pokud došlo k uzavření pojistné smlouvy před 1.11.2002, může být hodnota
				pojistné částky 0,- Kč. V takovém případě se dle pojistných podmínek v
				případě pojistné události smrt pojištěného vyplácí hodnota podílových
				jednotek.
			</p>
		</>
	),
	T210: (
		<>
			<h2>T210 - Životní pojištění Investice</h2>
		</>
	),
	T250: (
		<>
			<h2>T250 - Investiční životní pojištění Investor Plus </h2>
		</>
	),
	T500: (
		<>
			<h2>T500 - Životní pojištění Garant Invest</h2>
		</>
	),
	T510: (
		<>
			<h2> Kód pojistného krytí: T510 </h2>
			<p>
				NN Garance Plus je jednorázově placené životní pojištění určené občanům
				i firmám k zhodnocování volných finančních prostředků prostřednictvím
				investice na 5 let. Při splatnosti vyplácí garantovaný fond investorům
				celou hodnotu počáteční investice a potenciální výnos. Tento produkt v
				sobě kombinuje možnost investice s prvky pojistné ochrany.
			</p>
		</>
	),
	TMR0: (
		<>
			<h2>TMR0 - Dočasné životné poistenie</h2>
		</>
	),
	TMR3: (
		<>
			<h2>TMR3 - Dočasné životné poistenie</h2>
		</>
	),
	TMR4: (
		<>
			<h2>TMR4 - Dočasné životné poistenie</h2>
		</>
	),
	TMR5: (
		<>
			<h2>TMR5 - Dočasné životné poistenie</h2>
		</>
	),
	TRF4: (
		<>
			<h2>TRF4 - Dočasné životné poistenie</h2>
		</>
	),
	TRF5: (
		<>
			<h2>TRF5 - Dočasné životné poistenie</h2>
		</>
	),
	TRR0: (
		<>
			<h2>TRR0 - Dočasné životné pripoistenie</h2>
		</>
	),
	TRR2: (
		<>
			<h2>TRR2 - Úmrtie poisteného</h2>
		</>
	),
	TRR3: (
		<>
			<h2>TRR3 - Dočasné životné pripoistenie</h2>
		</>
	),
	TRR4: (
		<>
			<h2>TRR4 - Dočasné životné pripoistenie</h2>
		</>
	),
	TRR5: (
		<>
			<h2>TRR5 - Dočasné životné pripoistenie</h2>
		</>
	),
	TRS1: (
		<>
			<h2>TRS1 - Dočasné životné pripoistenie</h2>
		</>
	),
	TTU4: (
		<>
			<h2>TTU4 - Mimoriadne poistné</h2>
		</>
	),
	U006: (
		<>
			<h2>Kód pojistného krytí: U006</h2>
			<p>
				POPIS: Připojištění pro případ zproštění od placení pojistného zajišťuje
				pojistníkovi prostředky na platbu pojistného (za všechna
				pojištění/připojištění na pojistné smlouvě) v případě, že by byl uznán
				invalidním 3. stupně (dříve plně invalidním). V takovém případě je
				pojistník zproštěn od povinnosti platit pojistné (pojistné za pojistníka
				hradí pojišťovna). Pojistné krytí přitom zůstává tak, jak je.
			</p>
			<p>
				POJISTNÁ UDÁLOST: 3. stupeň invalidity (dříve plná invalidita). Pokles
				pracovní schopnosti z důvodu dlouhodobě nepříznivého zdravotního stavu
				musí být nejméně o 70 % + 3. stupeň invalidity musí být uznán v rámci
				posudku příslušného orgánu sociální zprávy (ČSSZ).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Zproštění pojistníka od povinnosti platit pojistné za
				hlavní krytí i veškerá připojištění sjednaná v pojistné smlouvě
				(pojistné za pojistníka hradí pojišťovna).
			</p>
		</>
	),
	U012: (
		<>
			<h2>Kód pojistného krytí: U012</h2>
			<p>
				POPIS: Připojištěním pro případ smrti následkem úrazu se zvyšuje
				pojistné plnění pro případ smrti způsobené úrazem.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz, ke kterému došlo v průběhu trvání pojištění a
				který do 3 let způsobí smrt pojištěného.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistná částka platná k datu pojistné události v
				případě smrti úrazem.
			</p>
		</>
	),
	U014: (
		<>
			<h2>Kód pojistného krytí: U014</h2>
			<p>
				POPIS: Připojištění pro případ smrti následkem úrazu a trvalých následků
				úrazu zajišťuje finanční prostředky pro případ, kdy úraz zanechá trvalé
				následky nebo způsobí smrt pojištěného.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Smrt následkem úrazu nebo trvalé následky způsobené
				úrazem (vždy jen došlo-li k úmrtí/trvalým následkům do tří let ode dne
				úrazu).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: V případě smrti následkem úrazu je vyplacena pojistná
				částka platná k datu pojistné události. V případě trvalých následků
				vyplatí pojišťovna příslušné procento z pojistné částky platné ke dni
				vzniku pojistné události (jak je toto procento uvedeno v příloze
				pojistných podmínek pro jednotlivé typy trvalých následků).
			</p>
		</>
	),
	U018: (
		<>
			<h2>Kód pojistného krytí: U018</h2>
			<p>
				Název připojištění: Připojištění úrazu a trvalých následků úrazu dítěte
			</p>
			<p>
				Popis připojištění: Připojištění úrazu a trvalých následků úrazu dítěte
				poskytuje finanční pomoc v případě trvalého poškození po úrazu dítěte.
				Každý z nás je denně vystaven mnoha rizikům, a proto potřebujeme mít
				pojištěny malé i velké úrazy. Od toho je zde právě připojištění úrazů
				dítěte a jejich trvalých následků s pojistným plněním od 1 % pojistné
				částky.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<ol>
				<li> Úraz uvedený v příloze pojistných podmínek;</li>
				<li>
					Trvalé následky úrazu uvedené v příloze pojistných podmínek nastalé do
					3 let od data úrazu;
				</li>
				<li>
					Hospitalizace v důsledku úrazu (musí trvat minimálně 8 po sobě
					následujících dní).
				</li>
			</ol>
		</>
	),
	U024: (
		<>
			<h2>Kód pojistného krytí: U024</h2>
			<p>
				Název připojištění: Připojištění pro případ plného invalidního důchodu
				následkem úrazu
			</p>
			<p>
				Popis připojištění: Připojištění pro případ 3. stupně invalidity (dříve
				plná invalidita) následkem úrazu poskytuje ochranu v případech, kdy se
				vlivem úrazu pojištěný stane invalidním, výrazně poklesne jeho schopnost
				soustavné výdělečné činnosti nebo je soustavné výdělečné činnosti
				schopen jen za zcela mimořádných podmínek. Díky tomuto připojištění se
				právě v těchto případech pojištěný nemusí obávat snížení svého životního
				standardu.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Uznání 3. stupně invalidity (dříve plná invalidita)
				následkem úrazu vymezeného v pojistných podmínkách, jestliže následně z
				důvodu dlouhodobě nepříznivého zdravotního stavu pojištěného došlo k
				poklesu jeho schopnosti soustavné výdělečné činnosti o stanovené
				procento nebo pro zdravotní postižení je schopen soustavné výdělečné
				činnosti jen za zcela mimořádných podmínek.
			</p>
		</>
	),
	U053: (
		<>
			<h2>Kód pojistného krytí: U053</h2>
			<p>
				Název připojištění: Připojištění pro případ smrti nebo diagnózy
				závažného onemocnění
			</p>
			<p>
				Popis připojištění: Připojištění pro případ smrti nebo diagnózy
				závažného onemocnění poskytuje účinnou ochranu pro případ, že Vás
				postihne některé ze závažných onemocnění, jako je srdeční infarkt,
				mrtvice, rakovina, selhání ledvin, transplantace důležitých orgánů,
				náhrada srdeční chlopně, operace aorty, AIDS, HIV infekce, oslepnutí,
				ztráta sluchu, operace věnčitých tepen – bypass, nitrolební nádory
				nezhoubného původu, angioplastika nebo roztroušená skleróza.
				Pravděpodobně to negativně ovlivní nejen Váš život, ale i rodinný
				rozpočet. Právě pro tyto případy se hodí připojištění pro případ
				diagnózy závažných onemocnění nebo smrti, které v tu chvíli zajistí Vaší
				rodině peněžní prostředky ve výši sjednané pojistné částky.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<ol type="a">
					<li>
						Výskyt některého ze závažných onemocnění uvedených v příloze
						pojistných podmínek;
					</li>
					<li>Smrt pojištěného.</li>
				</ol>
			</p>
		</>
	),
	U118: (
		<>
			<h2>Kód pojistného krytí: U118</h2>
			<p>
				Název připojištění: Připojištění trvalých následků úrazu dítěte s
				progresivním plněním
			</p>
			<p>
				Popis připojištění: Připojištění trvalých následků úrazu dítěte s
				progresivním plněním poskytuje účinnou ochranu zaručující finanční
				odškodnění v případě trvalého poškození po úrazu dítěte. Každý z nás je
				denně vystaven mnoha rizikům, a proto potřebujeme mít pojištěny malé i
				velké úrazy. Právě od toho je zde připojištění trvalých následků s
				progresivním plněním až 400 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající do 3 let od svého vzniku trvalé
				následky uvedené v příloze pojistných podmínek.
			</p>
		</>
	),
	U120: (
		<>
			<h2>U120 - Investiční životní pojištění</h2>
		</>
	),
	U140: (
		<>
			<h2>U140 - Investiční životní pojištění (od 1.4.2007 TOP Life)</h2>
		</>
	),
	U150: (
		<>
			<h2>U150 - Investiční životní pojištění STRATEGIE U150</h2>
		</>
	),
	U21C: (
		<>
			<h2>Kód pojistného krytí: U21C</h2>
			<p>
				POPIS: Hlavní krytí pro 2. pojištěného - Životní pojištění NN Smart /
				Životní pojištění ZFP Život+.
			</p>
		</>
	),
	U21S: (
		<>
			<h2>U21S - Poistenie pre prípad smrti</h2>
		</>
	),
	U510: (
		<>
			<h2>U510 - Investiční pojištění Junior Top</h2>
		</>
	),
	U540: (
		<>
			<h2>
				U540 - Investiční pojištění JUNIOR (od 1.1.2005 Investiční pojištění
				JUNIOR PLUS)
			</h2>
		</>
	),
	UAS0: (
		<>
			<h2>UAS0 - Zlatý dolár</h2>
		</>
	),
	UAS1: (
		<>
			<h2>UAS1 - Zlatý dolár</h2>
		</>
	),
	UBR1: (
		<>
			<h2>UBR1 - Investičné poistenie Investor</h2>
		</>
	),
	UBR2: (
		<>
			<h2>UBR2 - HypoInvestor</h2>
		</>
	),
	H101: (
		<>
			<h2>Kód pojistného krytí: H101</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici následkem úrazu
				poskytuje pojistnou ochranu pro případ hospitalizace následkem úrazu.
				Díky těmto finančním prostředkům si můžete zajistit nadstandardní
				nemocniční péči, sjednat pomoc v domácnosti v době své nepřítomnosti
				nebo pomoci své rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace v důsledku úrazu (musí trvat v minimálně
				4 po sobě jdoucí kalendářní dny).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů.
			</p>
		</>
	),
	H302: (
		<>
			<h2>Kód pojistného krytí: H302</h2>
			<p>
				POPIS: Připojištění denní dávky při pracovní neschopnosti následkem
				úrazu zajišťuje finanční pomoc v případě, kdy pojištěný nemůže podle
				lékařského rozhodnutí žádným způsobem vykonávat a nevykonává své
				zaměstnání nebo svou samostatnou výdělečnou činnost. Vyplácenou denní
				dávkou si může zajistit nadstandardní nemocniční péči či sjednat pomoc v
				domácnosti.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost pojištěného
				(podmínkou je trvání pracovní neschopnosti minimálně 15 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka k datu pracovní neschopnosti od
				15. dne trvání pracovní neschopnosti. Maximální délka výplaty denní
				dávky je 52 týdnů.
			</p>
		</>
	),
	H304: (
		<>
			<h2>Kód pojistného krytí: H304</h2>
			<p>
				POPIS: Připojištění denní dávky při pracovní neschopnosti následkem
				úrazu zajišťuje finanční pomoc v případě, kdy pojištěný nemůže podle
				lékařského rozhodnutí žádným způsobem vykonávat a nevykonává své
				zaměstnání nebo svou samostatnou výdělečnou činnost. Vyplácenou denní
				dávkou si může zajistit nadstandardní nemocniční péči či sjednat pomoc v
				domácnosti.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Lékařsky potvrzená pracovní neschopnost pojištěného
				(podmínkou je trvání pracovní neschopnosti minimálně 15 dní).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka k datu pracovní neschopnosti od
				29. dne trvání pracovní neschopnosti. Maximální délka výplaty denní
				dávky je 52 týdnů .
			</p>
		</>
	),
	HAR0: (
		<>
			<h2>HAR0 - Pripoistenie hospitalizácie</h2>
		</>
	),
	HAR3: "-",
	HDR0: (
		<>
			<h2>HDR0 - Pripoistenie poúrazovej hospitalizácie</h2>
		</>
	),
	HDR1: (
		<>
			<h2>HDR1 - Pripoistenie poúrazovej hospitalizácie</h2>
		</>
	),
	HDR2: (
		<>
			<h2>HDR2 - Hospitalizácia v dôsledku úrazu</h2>
		</>
	),
	UBR3: (
		<>
			<h2>UBR3 - Investičné poistenie Investor Plus</h2>
		</>
	),
	UG10: (
		<>
			<h2>UG10 - Investičné poistenie Garanting</h2>
		</>
	),
	UL01: "-",
	UL02: "-",
	UL03: (
		<>
			<h2>UL03 - Finanční fondy životního pojištění</h2>
		</>
	),
	UL04: (
		<>
			<h2>UL04 - Finanční fondy životního pojištění</h2>
		</>
	),
	ULR1: (
		<>
			<h2>ULR1 - Investičné životné poistenie</h2>
		</>
	),
	ULR2: (
		<>
			<h2>ULR2 - Investičné životné poistenie, zamestnanecké</h2>
		</>
	),
	ULR3: (
		<>
			<h2>ULR3 - Investičné poistenie Favorit</h2>
		</>
	),
	ULR4: (
		<>
			<h2>ULR4 - Investičné poistenie Investing</h2>
		</>
	),
	ULR6: (
		<>
			<h2>ULR6 - Poistenie HypoInvesting</h2>
		</>
	),
	ULRB: (
		<>
			<h2>ULRB - Skupinové investičné životné poistenie</h2>
		</>
	),
	ULRH: (
		<>
			<h2>ULRH - Skupinové investičné životné poistenie</h2>
		</>
	),
	ULRJ: (
		<>
			<h2>ULRJ - Detské investičné poistenie</h2>
		</>
	),
	ULRK: (
		<>
			<h2>ULRK - Detské investičné poistenie, zamestnanecké</h2>
		</>
	),
	HDR3: "-",
	IG01: (
		<>
			<h2>IG01 - Finanční fondy životního pojištění s garantovanou výplatou</h2>
		</>
	),
	IM1S: (
		<>
			<h2>IM1S - Investičné životné poistenie Invest Life</h2>
		</>
	),
	IM2S: (
		<>
			<h2>IM2S - Investičné životné poistenie TopLife</h2>
		</>
	),
	IU01: (
		<>
			<h2>IU01 - Finanční fondy životního pojištění</h2>
		</>
	),
	JAR1: (
		<>
			<h2>JAR1 - Poistná suma na úraz</h2>
		</>
	),
	KD1C: (
		<>
			<h2>Kód pojistného krytí: KD1C</h2>
			<p>
				POPIS: Kapitálově důchodové pojištění poskytuje ochranu pro případ smrti
				a kombinuje ji s vytvářením úspor. Plnění při dožití můžete využít pro
				zabezpečení financí v důchodovém věku. Jeho výhodou je velká
				flexibilita, díky které můžete pojištění v jeho průběhu přizpůsobovat
				Vaší aktuální životní situaci, potřebám a možnostem. V případě, že byl
				pojistník uznán invalidním ve 3. stupni (dříve plně invalidním), dochází
				ke zproštění od povinnosti platit běžné pojistné a pojistné na celé
				smlouvě hradí pojišťovna Toto pojištění je vhodné také pro ty, co chtějí
				ušetřit na daních.
			</p>
			<p>POJISTNÁ UDÁLOST:</p>
			<div className="li">
				<p>
					<b>a)</b> Smrt pojištěného z jakékoliv příčiny.
				</p>
				<p>
					<b>b)</b> Dožití se sjednaného konce pojištění pojištěným.
				</p>
				<p>
					<b>c)</b> Uznání 3. stupně invalidity (dříve plná invalidita).
				</p>
			</div>

			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši celkově
					zaplaceného běžného pojistného na hlavní krytí zvýšeného o případný
					podíl na zisku.
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění pojištěným
					pojistné plnění ve výši pojistné částky pro případ dožití se
					sjednaného konce pojištění zvýšené o případný podíl na zisku.
					<br />
					<b>c)</b> V případě uznání 3. stupně invalidity (dříve plná
					invalidita) pojistníka zproštění pojistníka od povinnosti platit
					pojistné za hlavní krytí i veškerá připojištění sjednaná v pojistné
					smlouvě (pojistné za pojistníka hradí pojišťovna).
				</div>
			</p>
			<p>
				<strong>
					Zde na portálu zobrazovaná pojistná částka v pojistném krytí
					pojištěného je pojistnou částkou pro případ dožití se sjednaného konce
					pojištění pojištěným.
				</strong>
			</p>
		</>
	),
	KK1S: (
		<>
			<h2>KK1S - Životné poistenie Komplet</h2>
		</>
	),
	KK2S: (
		<>
			<h2>KK2S - Životné poistenie Komplet</h2>
		</>
	),
	KR1C: (
		<>
			<h2>Kód pojistného krytí: KR1C</h2>
			<p>
				POPIS: Životní pojištění Rodina Vám umožňuje pojistit na jedné smlouvě
				sebe i další členy své rodiny. Jeho výhodou je velká flexibilita, díky
				které můžete pojištění v průběhu přizpůsobovat Vaší aktuální životní
				situaci, svým potřebám a možnostem. Poskytuje ochranu proti riziku smrti
				a současně Vám umožňuje vytvářet finanční rezervu. Vhodné je také pro
				ty, co chtějí ušetřit na daních.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS21).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného pojistné plnění ve výši
					celkově zaplaceného běžného pojistného na hlavní krytí 1. pojištěného
					+ hodnota podílového účtu (popř. hodnota čistého vkladu,
					investovalo-li se dle pojistných podmínek mimořádné pojistné do fondů
					s garantovanou výplatou) + i případně hodnota jednorázového vkladu,
					byl-li dle pojistných podmínek vložen;
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši pojistné částky pro případ dožití se
					sjednaného konce pojištění zvýšené o případný podíl na zisku (tzv.
					věrnostní bonus) + hodnota podílového účtu + i případně hodnota
					jednorázového vkladu, byl-li dle pojistných podmínek vložen (součástí
					tvorby kapitálové hodnoty); a <br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
			<p>
				<strong>
					Zde na portálu zobrazovaná pojistná částka v pojistném krytí 1.
					pojištěného je pojistnou částkou pro případ dožití se sjednaného konce
					pojištění 1. pojištěným.
				</strong>
			</p>
		</>
	),
	KZ1C: (
		<>
			<h2>Kód pojistného krytí: KZ1C</h2>
			<p>
				POPIS: Kapitálové životní pojištění v sobě kombinuje pojistnou ochranu
				pro případ smrti a vytváření úspor. Plnění při dožití můžete využít pro
				zabezpečení financí v důchodovém věku. Jeho výhodou je velká
				flexibilita, díky které můžete pojištění v jeho průběhu přizpůsobovat
				Vaší aktuální životní situaci, potřebám a možnostem. V případě, že byl
				pojistník uznán invalidním ve 3. stupni (dříve plně invalidním), dochází
				ke zproštění od povinnosti platit běžné pojistné a pojistné na celé
				smlouvě hradí pojišťovna). Toto pojištění je vhodné také pro ty, co
				chtějí ušetřit na daních.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt pojištěného z jakékoliv příčiny.
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění pojištěným.
					<br />
					<b>c)</b> Uznání 3. stupně invalidity (dříve plná invalidita).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti pojištěného pojistné plnění ve výši celkově
					zaplaceného běžného pojistného na hlavní krytí zvýšeného o případný
					podíl na zisku.
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění pojištěným
					pojistné plnění ve výši pojistné částky pro případ dožití se
					sjednaného konce pojištění zvýšené o případný podíl na zisku.
					<br />
					<b>c)</b> V případě uznání 3. stupně invalidity (dříve plná
					invalidita) pojistníka zproštění pojistníka od povinnosti platit
					pojistné za hlavní krytí i veškerá připojištění sjednaná v pojistné
					smlouvě (pojistné za pojistníka hradí pojišťovna).
				</div>
			</p>
		</>
	),
	KZ2C: (
		<>
			<h2>KZ2C - Kapitálové životní pojištění</h2>
		</>
	),
	ULRL: (
		<>
			<h2>ULRL - Detské investičné poistenie</h2>
		</>
	),
	UM1C: (
		<>
			<h2>Kód pojistného krytí: UM1C</h2>
			<p>
				POPIS: Investiční životní pojištění NN Smart nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód U21C).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného podle v pojistné smlouvě
					sjednané varianty pojistného plnění:
					<br /> - ve výši pojistné částky pro případ smrti 1. pojištěného nebo
					ve výši hodnoty podílového účtu, je-li tato hodnota vyšší – tzv.
					varianta „vyšší z“, nebo
					<br />- ve výši součtu hodnoty podílového účtu a pojistné částky pro
					případ smrti 1. pojištěného (pojistné částky konstantní / pojistné
					částky lineárně klesající / pojistné částky klesající podle
					splátkového kalendáře).
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	UM1S: (
		<>
			<h2>UM1S - Životní pojištění ProAktiv</h2>
		</>
	),
	UM2C: (
		<>
			<h2>Kód pojistného krytí: UM2C</h2>
			<p>
				POPIS: Investiční životní pojištění NN Smart nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS21).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného podle v pojistné smlouvě
					sjednané varianty pojistného plnění:
					<br /> - ve výši pojistné částky pro případ smrti 1. pojištěného nebo
					ve výši hodnoty podílového účtu, je-li tato hodnota vyšší – tzv.
					varianta „vyšší z“, <b>nebo</b>
					<br />- ve výši součtu hodnoty podílového účtu a pojistné částky pro
					případ smrti 1. pojištěného (pojistné částky konstantní / pojistné
					částky lineárně klesající / pojistné částky klesající podle
					splátkového kalendáře).
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	UM3C: (
		<>
			<h2>Kód pojistného krytí: UM3C</h2>
			<p>
				POPIS:Investiční životní pojištění ZFP Život+ nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód U21C).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného podle v pojistné smlouvě
					sjednané varianty pojistného plnění:
					<br /> - ve výši pojistné částky pro případ smrti 1. pojištěného nebo
					ve výši hodnoty podílového účtu, je-li tato hodnota vyšší – tzv.
					varianta „vyšší z“, nebo
					<br />- ve výši součtu hodnoty podílového účtu a pojistné částky pro
					případ smrti 1. pojištěného (pojistné částky konstantní / pojistné
					částky lineárně klesající / pojistné částky klesající podle
					splátkového kalendáře).
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	UM3S: (
		<>
			<h2>UM3S - Životné poistenie ZFP Život +</h2>
		</>
	),
	UM4C: (
		<>
			<h2>Kód pojistného krytí: UM4C</h2>
			<p>
				POPIS: Investiční životní pojištění ZFP Život+ nabízí komplexní výhody
				ve formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS21).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného podle v pojistné smlouvě
					sjednané varianty pojistného plnění:
					<br /> - ve výši pojistné částky pro případ smrti 1. pojištěného nebo
					ve výši hodnoty podílového účtu, je-li tato hodnota vyšší – tzv.
					varianta „vyšší z“, nebo
					<br />- ve výši součtu hodnoty podílového účtu a pojistné částky pro
					případ smrti 1. pojištěného (pojistné částky konstantní / pojistné
					částky lineárně klesající / pojistné částky klesající podle
					splátkového kalendáře).
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	US20: (
		<>
			<h2>US20 - Investiční životní pojištění</h2>
		</>
	),
	US40: (
		<>
			<h2>US40 - Investiční pojištění JUNIOR</h2>
		</>
	),
	UTU4: (
		<>
			<h2>UTU4 - Finančné fondy životného poistenia</h2>
		</>
	),
	UZ1C: (
		<>
			<h2>Kód pojistného krytí: UZ1C</h2>
			<p>
				POPIS: Investiční životní pojištění NN Smart nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód U21C).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného podle v pojistné smlouvě
					sjednané varianty pojistného plnění:
					<br /> - ve výši pojistné částky pro případ smrti 1. pojištěného nebo
					ve výši hodnoty podílového účtu, je-li tato hodnota vyšší – tzv.
					varianta „vyšší z“, nebo
					<br />- ve výši součtu hodnoty podílového účtu a pojistné částky pro
					případ smrti 1. pojištěného (pojistné částky konstantní / pojistné
					částky lineárně klesající / pojistné částky klesající podle
					splátkového kalendáře).
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	UZ1S: (
		<>
			<h2>UZ1S - Životné poistenie NN Smart</h2>
		</>
	),
	UZ2C: (
		<>
			<h2>Kód pojistného krytí: UZ2C</h2>
			<p>
				POPIS: Investiční životní pojištění NN Smart nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS21).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného podle v pojistné smlouvě
					sjednané varianty pojistného plnění:
					<br /> - ve výši pojistné částky pro případ smrti 1. pojištěného nebo
					ve výši hodnoty podílového účtu, je-li tato hodnota vyšší – tzv.
					varianta „vyšší z“, <b>nebo</b>
					<br />- ve výši součtu hodnoty podílového účtu a pojistné částky pro
					případ smrti 1. pojištěného (pojistné částky konstantní / pojistné
					částky lineárně klesající / pojistné částky klesající podle
					splátkového kalendáře).
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	M010: (
		<>
			<h2>M010 - Dočasné životní pojištění</h2>
		</>
	),
	M018: (
		<>
			<h2>M018 - Připojištění dítěte</h2>
		</>
	),
	M024: (
		<>
			<h2>M024 - Připojištění plného invalidního důchodu následkem úrazu</h2>
		</>
	),
	M040: (
		<>
			<h2>M040 - Smrt úrazem</h2>
		</>
	),
	M041: (
		<>
			<h2>M041 - Trvalé následky úrazu</h2>
		</>
	),
	M042: (
		<>
			<h2>M042 - Plný invalidní důchod v důsledku úrazu</h2>
		</>
	),
	M050: (
		<>
			<h2>M050 - Smrt úrazem</h2>
		</>
	),
	M051: (
		<>
			<h2>M051 - Trvalé následky úrazu</h2>
		</>
	),
	M053: (
		<>
			<h2>M053 - Připojištění smrti</h2>
		</>
	),
	M110: (
		<>
			<h2>M110 - Manažerské životní pojištění</h2>
		</>
	),
	M120: (
		<>
			<h2>M120 - Manažerské životní pojištění</h2>
		</>
	),
	M220: (
		<>
			<h2>M220 - Smrt nebo diagnóza závažného onemocnění</h2>
		</>
	),
	M320: (
		<>
			<h2>M320 - Pojištění smrti</h2>
		</>
	),
	NG11: (
		<>
			<h2>NG11 - Doživotný dôchodok s garantovanou dobou výplaty</h2>
		</>
	),
	W060: (
		<>
			<h2>W060 - Zproštění od placení pojistného</h2>
		</>
	),
	W061: (
		<>
			<h2>W061 - Zproštění od placení pojistného v důsledku úrazu</h2>
		</>
	),
	W063: (
		<>
			<h2>
				W063 - Připojištění zproštění od placení pojistného z jakékoliv příčiny
			</h2>
		</>
	),
	W9R0: (
		<>
			<h2>W9R0 - Horizont 95</h2>
		</>
	),
	W9R3: (
		<>
			<h2>W9R3 - Horizont 95</h2>
		</>
	),
	W9RS: "-",
	WLR0: (
		<>
			<h2>WLR0 - Horizont 65</h2>
		</>
	),
	WLR3: (
		<>
			<h2>WLR3 - Horizont 65</h2>
		</>
	),
	WLRP: "-",
	WLS0: (
		<>
			<h2>WLS0 - Horizont</h2>
		</>
	),
	WLS3: (
		<>
			<h2>WLS3 - Horizont</h2>
		</>
	),
	WLSP: "-",
	WLSS: "-",
	WPR0: (
		<>
			<h2>WPR0 - Oslobodenie od platenia poistného</h2>
		</>
	),
	WPR1: (
		<>
			<h2>WPR1 - Oslobodenie od platenia poistného</h2>
		</>
	),
	WPR2: (
		<>
			<h2>WPR2 - Invalidita - oslobodenie od platenia poistného</h2>
		</>
	),
	WPR3: (
		<>
			<h2>WPR3 - Oslobodenie od platenia poistného</h2>
		</>
	),
	UZ4C: (
		<>
			<h2>Kód pojistného krytí: UZ4C</h2>
			<p>
				POPIS: Investiční životní pojištění NN Smart nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS22).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného bude vyplacena výše pojistné
					částky pro případ smrti 1. pojištěného a výše hodnoty podílového účtu
					(neplatí pro smlouvy vzniklé konverzí, které nabízí více variant
					plnění).
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	UM7C: (
		<>
			<h2>Kód pojistného krytí: UM7C</h2>
			<p>
				POPIS: Investiční životní pojištění NN Smart nabízí komplexní výhody ve
				formě optimální pojistné ochrany a možnosti vytvořit si finanční
				rezervu. Tento pojistný produkt je mimořádně flexibilní a maximálně se
				tak přizpůsobí Vašim aktuálním životním potřebám. Umožňuje pojistit na
				jedné smlouvě sebe i další členy rodiny.
			</p>
			<p>
				POJISTNÁ UDÁLOST:
				<div className="li">
					<b>a)</b> Smrt 1. pojištěného z jakékoliv příčiny,
					<br />
					<b>b)</b> Dožití se sjednaného konce pojištění 1. pojištěným,
					<br />
					<b>c)</b> Smrt 2. pojištěného z jakékoliv příčiny (viz kód CS22).
				</div>
			</p>
			<p>
				POJISTNÉ PLNĚNÍ:
				<div className="li">
					<b>a)</b> V případě smrti 1. pojištěného bude vyplacena výše pojistné
					částky pro případ smrti 1. pojištěného a výše hodnoty podílového účtu
					(neplatí pro smlouvy vzniklé konverzí, které nabízí více variant
					plnění).
					<br />
					<b>b)</b> V případě dožití se sjednaného konce pojištění 1. pojištěným
					pojistné plnění ve výši hodnoty podílového účtu.
					<br />
					<b>c)</b> V případě smrti 2. pojištěného pojistné plnění ve výši
					pojistné částky pro případ smrti 2. pojištěného.
				</div>
			</p>
		</>
	),
	CHO5: (
		<>
			<h2>Kód pojistného krytí: CHO5</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici poskytuje
				pojistnou ochranu pro případ hospitalizace. Díky těmto finančním
				prostředkům si můžete zajistit nadstandardní nemocniční péči, sjednat
				pomoc v domácnosti v době své nepřítomnosti nebo pomoci své rodině s
				cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>POJISTNÁ UDÁLOST: Hospitalizace (musí trvat minimálně 24 hodin).</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů. V případě
				hospitalizace, které trvá nepřetržitě alespoň 10 dní, vyplatí pojišťovna
				dvojnásobek sjednané denní dávky. V případě hospitalizace z důvodu
				těhotenství (s výjimkou porodu nebo umělého přerušení těhotenství)
				vyplatí pojišťovna dvojnásobek sjednané denní dávky. V případě
				hospitalizace z důvodu porodu, která trvá nepřetržitě alespoň 4 dny,
				vyplatí pojišťovna dvojnásobek sjednané denní dávky.
			</p>
		</>
	),
	CHU5: (
		<>
			<h2>Kód pojistného krytí: CHU5</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu v nemocnici následkem úrazu
				poskytuje pojistnou ochranu pro případ hospitalizace. Díky těmto
				finančním prostředkům si můžete zajistit nadstandardní nemocniční péči,
				sjednat pomoc v domácnosti v době své nepřítomnosti nebo pomoci své
				rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace v důsledku úrazu (musí trvat minimálně
				24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace.
				Maximální délka výplaty denní dávky je 52 týdnů. V případě
				hospitalizace, které trvá nepřetržitě alespoň 10 dní, vyplatí pojišťovna
				dvojnásobek sjednané denní dávky.
			</p>
		</>
	),
	CHO6: (
		<>
			<h2>Kód pojistného krytí: CHO6</h2>
			<p>
				POPIS: Připojištění denní dávky při pobytu dítěte v nemocnici poskytuje
				pojistnou ochranu pro případ hospitalizace. Díky těmto finančním
				prostředkům můžete zajistit dítěti nadstandardní nemocniční péči,
				sjednat pomoc v domácnosti v době své nepřítomnosti nebo pomoci své
				rodině s cestovními náklady při návštěvách v nemocnici.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Hospitalizace dítěte (musí trvat minimálně 24 hodin).
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Sjednaná denní dávka, a to za každý den hospitalizace
				dítěte. Maximální délka výplaty denní dávky je 52 týdnů. V případě
				hospitalizace, které trvá nepřetržitě alespoň 10 dní, vyplatí pojišťovna
				dvojnásobek sjednané denní dávky. V případě hospitalizace z důvodu
				těhotenství (s výjimkou porodu nebo umělého přerušení těhotenství)
				vyplatí pojišťovna dvojnásobek sjednané denní dávky. V případě
				hospitalizace z důvodu porodu, která trvá nepřetržitě alespoň 4 dny,
				vyplatí pojišťovna dvojnásobek sjednané denní dávky.
			</p>
		</>
	),
	SHU4: "-",
	CSO4: (
		<>
			<h2>Kód pojistného krytí: CSO4</h2>
		</>
	),
	CTN5: (
		<>
			<h2>Kód pojistného krytí: CTN5</h2>
			<p>
				POPIS: Připojištění pro případ trvalých následků úrazu s progresivním
				plněním od 1% poškození zajišťuje finanční pomoc v případě trvalého
				poškození po úrazu. Každý potřebuje mít pojištěny malé i velké úrazy,
				protože každý je denně vystaven mnoha rizikům (v dopravě, v práci, při
				sportu nebo hobby) a každý může mít vážné finanční problémy, když ho
				úraz vyřadí z výdělečné činnosti (na čas nebo i natrvalo). Od toho je
				zde právě připojištění trvalých následků, neomezeným počtem diagnóz
				(400+) s progresivním plněním až 800 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající trvalé následky uvedené v
				pojistných podmínkách, pokud jsou trvalé následky příslušným lékařem
				diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) odpovídající rozsahu trvalých následků.
			</p>
		</>
	),
	CTN6: (
		<>
			<h2>Kód pojistného krytí: CTN6</h2>
			<p>
				POPIS: Připojištění pro případ trvalých následků úrazu s progresivním
				plněním od 10% poškození zajišťuje finanční pomoc v případě trvalého
				poškození po úrazu. Každý potřebuje mít pojištěny malé i velké úrazy,
				protože každý je denně vystaven mnoha rizikům (v dopravě, v práci, při
				sportu nebo hobby) a každý může mít vážné finanční problémy, když ho
				úraz vyřadí z výdělečné činnosti (na čas nebo i natrvalo). Od toho je
				zde právě připojištění trvalých následků, neomezeným počtem diagnóz
				(400+) s progresivním plněním až 800 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz zanechávající trvalé následky uvedené v
				pojistných podmínkách, pokud jsou trvalé následky příslušným lékařem
				diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) odpovídající rozsahu trvalých následků.
			</p>
		</>
	),
	CTN7: (
		<>
			<h2>Kód pojistného krytí: CTN7</h2>
			<p>
				POPIS: Připojištění pro případ trvalých následků úrazu dítěte s
				progresivním plněním od 1% poškození poskytuje finanční pomoc v případě
				trvalého poškození po úrazu dítěte. Každý potřebuje mít pojištěny malé i
				velké úrazy, protože každý je denně vystaven mnoha rizikům. Od toho je
				zde právě připojištění trvalých následků s pojistným plněním, neomezeným
				počtem diagnóz (400+) s progresivním plněním až 800 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz dítěte zanechávající trvalé následky, pokud jsou
				trvalé následky příslušným lékařem diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) odpovídající rozsahu trvalých následků. V případě
				vyjmenovaných trvalých následků úrazu dítěte v obličeji, získává dítě
				automaticky navíc i tzv. &quot;dětské plnění&quot; trvalých následků
				úrazu v obličeji. V případě pojistné události, která nastane v období
				prázdnin od 1.7. - 31.8. a od 23.12. - 2.1., vyplatí pojišťovna
				dvojnásobné pojistné plnění.
			</p>
		</>
	),
	CTN8: (
		<>
			<h2>Kód pojistného krytí: CTN8</h2>
			<p>
				POPIS: Připojištění pro případ trvalých následků úrazu dítěte s
				progresivním plněním od 10% poškození poskytuje finanční pomoc v případě
				trvalého poškození po úrazu dítěte. Každý potřebuje mít pojištěny malé i
				velké úrazy, protože každý je denně vystaven mnoha rizikům. Od toho je
				zde právě připojištění trvalých následků s pojistným plněním, neomezeným
				počtem diagnóz (400+) s progresivním plněním až 800 %.
			</p>
			<p>
				POJISTNÁ UDÁLOST: Úraz dítěte zanechávající trvalé následky, pokud jsou
				trvalé následky příslušným lékařem diagnostikovány do 3 let od úrazu.
			</p>
			<p>
				POJISTNÉ PLNĚNÍ: Pojistné plnění ve výši příslušného procenta z pojistné
				částky platné ke dni vzniku pojistné události (jak je toto procento
				uvedeno v příloze pojistných podmínek pro jednotlivé typy trvalých
				následků) odpovídající rozsahu trvalých následků. V případě
				vyjmenovaných trvalých následků úrazu dítěte v obličeji, získává dítě
				automaticky navíc i tzv. &quot;dětské plnění&quot; trvalých následků
				úrazu v obličeji. V případě pojistné události, která nastane v období
				prázdnin od 1.7. - 31.8. a od 23.12. - 2.1., vyplatí pojišťovna
				dvojnásobné pojistné plnění.
			</p>
		</>
	),
	UM5S: (
		<>
			<h2>Investičné životné poistenie NN Smart - UM5S</h2>
		</>
	),
	SID5: (
		<>
			<h2>Kód pojistného krytí: SID5</h2>
			<p>
				<br />
				POPIS: Pripoistnie pre prípad invalidity s klesajúcou poistnou sumou
				poskytuje komplexnú poistnú ochranu pre prípad invalidity (čiastočnej aj
				úplnej) a poistený sa tak v týchto prípadoch nemusí obávať o zníženie
				svojho životného štandardu. Poistné plnenie z tohto pripoistenia je
				vyplácané formou jednorázového plnenia. Poistná suma je stanovená ako
				lineárne klesajúca a je k dátumu každého výročia zníženia o 1/n
				dohodnutej poistnej sumy, kde "n" predstavuje dohodnutú poistnú dobu v
				rokoch.
				<br />
				POISTNÁ UDALOSŤ: Výplata poistného plnenia v prípade vzniku nároku na
				priznanie invalidného dôchodku podľa stupňa invalidity a to: a) viac ako
				40 %, avšak najviac o 70 % (čiastočná invalidita) a b) o viac ako 70 %.
				<br />
				POISTNÉ PLNENIE: a) invalidita priznaná viac ako 40 %, najviac však o 70
				% = 50 % aktuálnej platnej poistnej sumy, b) invalidita priznaná viac
				ako 70 % = 100 % aktuálnej platnej poistnej sumy, v prípade vzniku
				invalidity z dôvodu kvadruplegie alebo teminálneho ochorenia sa vypláca
				150 % aktuálnej poistnej sumy.
			</p>
		</>
	),
	RM1S: (
		<>
			<h2>Kód poistného krytia: RM1S</h2>
			<p>
				<br />
				POPIS: Hlavné poistenie pre prvého poisteného s bonusom naviac v prípade
				smrti úrazom pri dopravnej nehode.
				<br />
				POISTNÁ UDALOSŤ: Smrť z akejkoľvek príčiny.
				<br />
				POISTNÉ PLNENIE: Poistné plnenie vo výške dohodnutej fixnej poistnej
				sumy. Pokiaľ k úrazu, ktorého následkom poistený zomrel, došlo pri
				dopravnej nehode v aute, autobuse,vlaku, lodi, lietadle, príp. ďalších
				dopravných prostredkov, zvyšuje sa poistné plnenie o bonus podľa
				uzatvorej poistnej zmluvy.
			</p>
		</>
	),
	R22S: (
		<>
			<h2>Kód poistného krytia: R22S</h2>
			<p>
				<br />
				POPIS: Hlavné poistenie pre druhého poisteného s bonusom naviac v
				prípade smrti úrazom pri dopravnej nehode.
				<br />
				POISTNÁ UDALOSŤ: Smrť z akejkoľvek príčiny.
				<br />
				POISTNÉ PLNENIE: Poistné plnenie vo výške dohodnutej fixnej poistnej
				sumy. Pokiaľ k úrazu, ktorého následkom poistený zomrel, došlo pri
				dopravnej nehode v aute, autobuse,vlaku, lodi, lietadle, príp. ďalších
				dopravných prostredkov, zvyšuje sa poistné plnenie o bonus podľa
				uzatvorej poistnej zmluvy.
			</p>
		</>
	),
	RZ2S: (
		<>
			<h2>Kód poistného krytia: RZ2S</h2>
			<p>
				<br />
				POPIS: Hlavné poistenie pre prvého poisteného s bonusom naviac v prípade
				smrti úrazom pri dopravnej nehode.
				<br />
				POISTNÁ UDALOSŤ: Smrť z akejkoľvek príčiny.
				<br />
				POISTNÉ PLNENIE: Poistné plnenie vo výške dohodnutej fixnej poistnej
				sumy. Pokiaľ k úrazu, ktorého následkom poistený zomrel, došlo pri
				dopravnej nehode v aute, autobuse,vlaku, lodi, lietadle, príp. ďalších
				dopravných prostredkov, zvyšuje sa poistné plnenie o bonus podľa
				uzatvorej poistnej zmluvy.
			</p>
		</>
	),
	SHO4: (
		<>
			<h2>Kód poistného krytia: SHO4</h2>
			<p>
				<br />
				POPIS: Pripoistenie hospitalizácie dieťaťa poskytuje poistnú ochranu
				deťom v prípade, že sú z dôvodu choroby alebo úrazu hospitalizované.
				Poistným plnením je možné znížiť si náklady spojené s liečbou dieťaťa,
				napríklad nadštandardnú liečbu, kvalitnejšie lieky, pomoc v domácnosti,
				ak jeden z rodičov robí sprievod dieťaťu v nemocničnom zariadení,
				prípadne pomoc pri úhrade poplatkov spojených so sprievodom rodiča v
				nemocničnom zariadení.
				<br />
				POISTNÁ UDALOSŤ: Hospitalizácia dieťaťa z dôvodu choroby alebo úrazu,
				ktorá je z lekárskeho hľadiska nevyhnutná a trvá minimálne 24 hodín
				nepretržite.
				<br />
				POISTNÉ PLNENIE: Denná dávka za každý kalendárny deň hospitalizácie.
				Poistné plnenie je poskytnuté v prípade, ak hospitalizácia trvá
				nepretržite minimálne 24 hodín. Maximálne je vyplatené poistné plnenie
				za 365 dní. Prvý a posledný deň sa počíta jako jeden. V prípade
				hospitalizácie, ktorá trvá nepretržite minimálne 10 dní, vyplatí
				poisťovateľ dvojnásobok dennej dávky. V prípade hospitalizácie z dôvodu
				tehotenstva (okrem pôrodu alebo umelého prerušenia tehotenstva), vyplatí
				poisťovateľ dvojnásobok dennej dávky. V prípade hospitalizácie z dôvodu
				pôrodu, ktorá trvá nepretržite minimálne 4 dni, vyplatí poisťovateľ
				dvojnásobok dennej dávky od 4. dňa.
			</p>
		</>
	),
	SHO5: (
		<>
			<h2>Kód poistného krytia: SHO5</h2>
			<p>
				<br />
				POPIS: Pripoistenie hospitalizácie poskytuje finančné prostriedky za
				každý deň hospitalizácie, vďaka ktorým je možné si zabezpečiť napríklad
				nadštandardnú starostlivosť alebo pomoc v domácnosti v čase
				hospitalizácie poisteného.
				<br />
				POISTNÁ UDALOSŤ: Hospitalizácia, ktorá je z lekárskeho hľadiska
				nevyhnutná z dôvodu choroby alebo úrazu, a ktorá trvá nepretržite
				minimálne 24 hodín.
				<br />
				POISTNÉ PLNENIE: Denná dávka za každý kalendárny deň hospitalizácie.
				Poistné plnenie je poskytnuté v prípade, ak hospitalizácia trvá
				nepretržite minimálne 24 hodín. Maximálne je vyplatené poistné plnenie
				za 365 dní. Prvý a posledný deň sa počíta jako jeden. V prípade
				hospitalizácie, ktorá trvá nepretržite minimálne 10 dní, vyplatí
				poisťovateľ dvojnásobok dennej dávky. V prípade hospitalizácie z dôvodu
				tehotenstva (okrem pôrodu alebo umelého prerušenia tehotenstva), vyplatí
				poisťovateľ dvojnásobok dennej dávky. V prípade hospitalizácie z dôvodu
				pôrodu, ktorá trvá nepretržite minimálne 4 dni, vyplatí poisťovateľ od
				4. dňa dvojnásobok dennej dávky.
			</p>
		</>
	),
	SHU6: (
		<>
			<h2>Kód poistného krytia: SHU6</h2>
			<p>
				<br />
				POPIS: Pripoistenie poúrazovej hospitalizácie poskytuje finančné
				prostriedky na dobu nevyhnutnej hospitalizácie následkom úrazu, vďaka
				ktorým je možné si zabezpečiť napríklad nadštandardnú starostlivosť
				alebo pomoc v domácnosti v čase hospitalizácie poisteného aj v staršom
				veku.
				<br />
				POISTNÁ UDALOSŤ: Hospitalizácia, ktorá je z lekárskeho hľadiska
				nevyhnutná z dôvodu úrazu, a ktorá trvá nepretržite minimálne 24 hodín.
				<br />
				POISTNÉ PLNENIE: Denná dávka za každý kalendárny deň hospitalizácie.
				Maximálna dĺžka trvania poúrazovej hospitalizácie je 365 dní. V prípade
				hospitalizácie, ktorá trvá nepretržite minimálne 10 dní, vyplatí
				poisťovateľ dvojnásobok dennej dávky.
			</p>
		</>
	),
	STN4: (
		<>
			<h2>Kód poistného krytia: STN4</h2>
			<p>
				<br />
				POPIS: Pripoistenie trvalých následkov úrazu dieťaťa s progresívnym
				plnením poskytuje finančnú pomoc v prípade trvalého poškodenia zdravia
				dieťaťa po úraze. Každý potrebuje mať poistené malé i veľké úrazy,
				pretože každý je denne vystavený mnohým rizikám. Práve pre to je tu
				Pripoistenie trvalých následkov s poistným plnením už od 1 % poškodenia
				tela, vysokým počtom krytých diagnóz (viac ako 400 a zároveň aplikovanie
				tzv. pripodobnenia úrazov) a s progresívnym plnením až do výšky 800 % z
				poistnej sumy.
				<br />
				POISTNÁ UDALOSŤ: Úraz dieťaťa zanechávajúci trvalé následky (t. j. stav
				označený lekárom ako trvalý), ak sú trvalé následky príslušným lekárom
				diagnostikované najneskôr do 3 rokov od úrazu.
				<br />
				POISTNÉ PLNENIE: PPoistné plnenie vo výške maximálneho príslušného
				percenta z poistnej sumy platnej ku dňu vzniku poistnej udalosti (ako je
				toto percento uvedené v prílohe osobitných poistných podmienok pre
				jednotlivé trvalé následky) zodpovedajúce rozsahu trvalých následkov
				úrazu. V prípade trvalých následkov úrazu dieťaťa na tvári (podľa
				prílohy osobitných poistných podmienok), získava dieťa automaticky
				navyše aj tzv. "detské plnenie". V prípade poistnej udalosti, ktorá
				nastane v období od 1.7. - 31.8. a od 23.12. - 6.1., vyplatí poisťovateľ
				dvojnásobné poistné plnenie.
			</p>
		</>
	),
	STN5: (
		<>
			<h2>Kód poistného krytia: STN5</h2>
			<p>
				<br />
				POPIS: Pripoistenie trvalých následkov úrazu s progresívnym plnením Vám
				pomôže sa finančne zabezpečiť v prípade trvalých následkov spôsobených
				úrazom. Každý je dennodenne vystavený rôznym rizikám úrazu či už doma, v
				práci alebo pri športe a každý môže mať následne veľké finančné
				problémy, pokiaľ mu úraz spôsobí trvalé obmedzenie výkonu zárobkovej
				činnosti. Práve pre to je tu Pripoistenie trvalých následkov s poistným
				plnením už od 1 % telesného poškodenia, s vysokým počtom krytých diagnóz
				(viac ako 400 a zároveň aplikovanie tzv. pripodobnenia úrazov) a s
				progresívnym plnením až do výšky 800% z poistnej sumy.
				<br />
				POISTNÁ UDALOSŤ: Úraz zanechávajúci trvalé následky (t. j. stav označený
				lekárom ako trvalý), ak sú trvalé následky príslušným lekárom
				diagnostikované najneskôr do 3 rokov od úrazu.
				<br />
				POISTNÉ PLNENIE: Poistné plnenie vo výške maximálneho príslušného
				percenta z poistnej sumy platnej ku dňu vzniku poistnej udalosti (ako je
				toto percento uvedené v prílohe osobitných poistných podmienok pre
				jednotlivé trvalé následky) zodpovedajúce rozsahu trvalých následkov
				úrazu.
			</p>
		</>
	),
	SDL1: (
		<>
			<h2>CDU1 - Připojištění bolestného za drobné úrazy</h2>
			<p>
				<br />
				POPIS: <br />
				POJISTNÁ UDÁLOST: <br />
				POJISTNÉ PLNĚNÍ:{" "}
			</p>
		</>
	),
	UL1S: "Názov poistného krytia:<br/> UL1S - Životné poistenie NN Smart",
};

export default riders;
